/*================ Polyfill =============*/
Object.assign = Object.assign || function(t,j) {
  if(!j) return t;
  for(var key in j) {
    t[key] = j[key]
  }
  return t;
}
Array.prototype.contains = Array.prototype.contains || function(obj) {
  return this.indexOf(obj) !== -1;
}
String.prototype.includes = String.prototype.includes || function(search, start) {
  'use strict';
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > this.length) {
    return false;
  } else {
    return this.indexOf(search, start) !== -1;
  }
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}

if(!String.prototype.escapeHTML) {
  String.prototype.escapeHTML = function() {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(this));
    return div.innerHTML;
  };
}


/*================ Tools ================*/
/*
 *  Cart
 *    Contains common Cart related functionality and tools, including an
 *    internally managed cart.
 *
 *  Dependencies:
 *    Ensure that window.Cart.data has been injected by liquid using
 *    window.Cart.data = window.Cart.data || {{ cart | json }};
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.Cart = window.Cart || {};

//Queue for Cart updates
window.Cart.queue = window.Cart.queue || [];
window.Cart.triggers = window.Cart.triggers || []; //Triggers to fire after cart update.



//Add
window.Cart.add = window.Cart.add || (function(variant, qty, callback) {
  if (typeof qty === typeof undefined) qty = 1;
  var startQueue = window.Cart.queue.length === 0;

  //Setup our tracking object
  var o = {
    variant: variant,
    quantity: qty,
    callback: callback,
    task: 'add',
    data: {
      id: variant,
      quantity: qty
    }
  };

  //Create our fake callback
  o.success = function(data) {
    window.Cart.nextItem();
    if (typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }.bind(o);

  //Add to the queue
  window.Cart.queue.push(o);
  if (startQueue) window.Cart.nextItem();
});


//Remove
window.Cart.remove = window.Cart.remove || (function(index, callback) {
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'remove',
    data: {
      line: index,
      quantity: 0
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});

//Update
window.Cart.update = window.Cart.update || (function(index, quantity, callback) {
  if(typeof quantity === typeof undefined) return;
  var startQueue = window.Cart.queue.length === 0;
  var o = {
    index: index,
    callback: callback,
    task: 'update',
    data: {
      line: index,
      quantity: quantity
    }
  };

  o.success = function(data) {
    window.Cart.nextItem();
    if(typeof this.callback === "function") this.callback(undefined, data);
  }.bind(o);

  o.error = function(e, i) {
    console.log(e);
    if(typeof this.callback === "function") this.callback(e);
    window.Cart.queue = [];
    $(document).trigger('onCartFinished');
  }

  window.Cart.queue.push(o);
  if(startQueue) window.Cart.nextItem();
});





//Queue Management
window.Cart.nextItem = window.Cart.nextItem || (function() {
  if (!window.Cart.queue.length) {

    //Fire pending triggers
    for (var i = 0; i < window.Cart.triggers.length; i++) {
      var t = window.Cart.triggers[i];
      if (t == 'add') {
        $(document).trigger('onCartAdded');
      } else if(t == 'remove') {
        $(document).trigger('onCartRemoved');
      } else if(t == 'update') {
        $(document).trigger('onCartQuantityUpdated');
      }
    }

    window.Cart.triggers = [];
    $(document).trigger('onCartFinished');
    return;
  }

  //Hint we're doing something with the cart.
  $(document).trigger('onCartPending');

  //Fetch the next task
  var item = window.Cart.queue.shift();

  //Switch
  if (item.task == 'add') {
    if (window.Cart.triggers.indexOf("add") === -1) {
      window.Cart.triggers.push('add');
    }

    $.ajax({
      url: '/cart/add.js?key=09efdae3e95e863b8c3d1631a9eeaac992f1c7d6e30eff0400982f9dce823643',
      method: "POST",
      dataType: "json",
      data: item.data,
      success: function(){qbHandleCart().then(function(cart){var item = cart.items[0]; return item; }).then(item.success)},
      error: item.error
    });
  } else if(item.task == 'remove' || item.task == 'update') {
    if(item.task == 'remove' && window.Cart.triggers.indexOf('remove') !== -1) {
      window.Cart.triggers.push('remove');
    } else if(item.task == 'update' && window.Cart.triggers.indexOf('update') !== -1) {
      window.Cart.triggers.push('update');
    }

    $.ajax({
      url: '/cart/change.js?key=09efdae3e95e863b8c3d1631a9eeaac992f1c7d6e30eff0400982f9dce823643',
      method: 'POST',
      dataType: "json",
      data: item.data,
      success: function(cart){ qbHandleCart(cart).then(function(cart){return cart; }).then(item.success)},
      error: item.error
    });
  } else if (item.task == 'get') {
    $.ajax({
      url: '/cart.js?key=09efdae3e95e863b8c3d1631a9eeaac992f1c7d6e30eff0400982f9dce823643',
      method: "GET",
      dataType: "json",
      success: item.success,
      error: item.error
    });
  }

  //All Done, if this has been a cart modification we're going to refetch
  //the cart to see if we have all the latest cart information that we need.
  if (item.task != 'get') {
    window.Cart.queue.push({
      task: 'get',
      success: window.Cart.onCartData,
      error: window.Cart.onCartError
    });
  }
});




window.Cart.onCartData = function(e) {
  //Semi Validate Cart
  if (typeof e === typeof undefined || typeof e.token === typeof undefined) {
    return window.Cart.onCartError(e);
  }

  //Cart is valid, first set it onto the global cart object
  window.Cart.data = e;

  //Now fire an event saying we received a cart update
  $(document).trigger('onCartUpdate', e);
  window.Cart.nextItem();
}

window.Cart.onCartError = function(a, b, c, d) {
  if (a) console.error(a);
  if (b) console.error(b);
  if (c) console.error(c);
  if (d) console.error(d);
  $(document).trigger('onCartFinished');
}

/*
 *  Currency
 *    Tools used for various currency/money related things
 *
 *  Dependencies:
 *    Recommended that window.Currency.format is set from your layout's .liquid file
 *    and injected into the window.Currency.format object
 *
 *    I also recommend window.Currency.currency is set from the layout's .liquid file
 *    as well.
 *
 *  Version:
 *    1.0.0 - 2018/02/09
 */
window.Currency = window.Currency || {};

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
window.Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
    dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
    cents   = parts[1] ? (decimal + parts[1]) : '';
    //return dollars + cents;
    return dollars
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

//Simple hook, this can allow for complex and custom money formatting.
window.Currency.getMoney = function(money) {
  return money;
};

/*
 *  Image Tools
 *    Provides a simple Javascript alternative to the tool.picture snippet, as
 *    well as some nice Shopify Image tools for use in Javascript
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
window.ImageTools = window.ImageTools || {};

window.ImageTools.getImageURL = window.ImageTools.getImageURL || (function(src,size) {
  if (typeof src === typeof undefined  || src === null) {
    //"No-Image" image
    return '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1400x.gif';
  }

  var removeProtocol = function(path) {
    return path.replace(/http(s)?:/, '');
  };

  if (size == null || size === 'master') return removeProtocol(src);

  size = "" + size;
  if(!size.endsWith("x")) size += "x";

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + '_' + size + suffix);
  } else {
    return null;
  }
});

window.ImageTools.generatePicture = window.ImageTools.generatePicture || (function(image, width, sizes, clazz, alt) {
  if(typeof width === typeof undefined || !width) width = 1400;
  if(typeof sizes === typeof undefined || !sizes || !sizes.length) sizes =  [500, 750, 1000];
  if(typeof alt === typeof undefined || !alt) alt = null;

  var ratios = [1, 2, 4];

  //TODO: Maybe we can enable some way of fetching the information about the
  //image here. (Mainly the image src, alt and dimensions if we can)
  var x = '<picture>';
  for(var i = 0; i < sizes.length; i++) {
    var s = sizes[i];
    x += '<source media="(';
    if(i != (sizes.length-1)) {
      x += 'max-width';
    } else {
      x += 'min-width';
    }

    x += ':'+s+'px)" srcset="';
    for(var y = 0; y < ratios.length; y++) {
      var r = ratios[y];
      x += window.ImageTools.getImageURL(image, s * r);
      if(r != 1) x += ' ' + r + 'x';
      if(y < (ratios.length-1)) y += ', ';
    }
    x += '" '
    if(alt) x += 'alt="'+alt+'" '
    x += '/>'
  }

  x += '<img src="'+window.ImageTools.getImageURL(image, width)+'" ';
  if(alt) x += 'alt="'+alt+'" ';
  if(clazz) x += 'class="'+clazz+'" ';
  x += '/>';
  x += '</picture>';
  return x;
});

/*
 *  Language
 *    Tools for Language options in Javascript
 *
 *  Dependencies:
 *    Add any used language keys to the widnow.Language.strings object.
 *
 *    I'm still toying with the idea of changing languages on the fly, I will look into this.
 *
 *  Version:
 *    1.0.0 - 2018/02/22
 */
window.Language = window.Language || {};
window.Language.strings = window.Language.strings || {};

//Mark a certain string as required, will display a handy debugging alert if it's not
window.Language.required = window.Language.required || (
  function(x) {
    if(typeof window.Language.strings[x] !== typeof undefined) return;
    $(document.body).prepend('<div style="position:fixed;top:0;left:0;background:red;color:white;z-index:9999999">Missing translation key ' + x + '</div>');//Temporarily disabled until I can think of a better solution
  }
);

window.Language.get = window.Language.get || (
  function(x) {
    return window.Language.strings[x] || 'Missing translation key ' + x;
  }
);

/*
 *  Query
 *    Tools used for reading/writing/manipulating the query string.
 *
 *  Dependencies:
 *
 *  Version:
 *    1.0.0 - 2018/02/12
 */

window.query = window.query || {};
window.queryTools = window.queryTools || {};

window.queryTools.decodeSearch = function(search) {
  var o = {};
  for (var aKeyValue, i = 0, aCouples = search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if(aKeyValue.length > 1) {
      o[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
  return o;
}

window.queryTools.setValue = function(name, value, updateHistory) {
  if(typeof updateHistory === typeof undefined) updateHistory = true;

  window.query[name] = value;

  if(updateHistory) {
    //Updates the query to have the new value and also updates the history object.
    var s = '?';
    var keys = Object.keys(window.query);
    for(var i = 0; i < keys.length; i++) {
      var k = keys[i];
      s += encodeURIComponent(k)+'='+encodeURIComponent(window.query[k]);
      if(i < keys.length-1) s += '&';
    }
    history.pushState(null, '', s);
  }
}


//Read the query string.
if(location.search.length) {
  window.query = window.queryTools.decodeSearch(location.search);
}

       (function(win) {
            'use strict';
            
            var listeners = [], 
            doc = win.document, 
            MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
            observer;
            
            function ready(selector, fn) {
                // Store the selector and callback to be monitored
                listeners.push({
                    selector: selector,
                    fn: fn
                });
                if (!observer) {
                    // Watch for changes in the document
                    observer = new MutationObserver(check);
                    observer.observe(doc.documentElement, {
                        childList: true,
                        subtree: true
                    });
                }
                // Check if the element is currently in the DOM
                check();
            }
                
            function check() {
                // Check the DOM for elements matching a stored selector
                for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
                    listener = listeners[i];
                    // Query for elements matching the specified selector
                    elements = doc.querySelectorAll(listener.selector);
                    for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                        element = elements[j];
                        // Make sure the callback isn't invoked with the 
                        // same element more than once
                        if (!element.ready) {
                            element.ready = true;
                            // Invoke the callback with the element
                            listener.fn.call(element, element);
                        }
                    }
                }
            }

            // Expose `ready`
            win.ready = ready;
                    
        })(this);

/*================ Objects ================*/
/*
 *  Accordion
 *    Scripts for accordion sliders
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    styles/objects/_accordion.scss - Styles for the accordion
 *
 *  Version:
 *    1.0.0 - 2018/02/12
 */
function Accordion(container) {
  this.container = container;
  this.id = (window.accordions = window.accordions || []).length;
  this.container.attr('data-id', this.id);
  this.slides = this.container.find('[data-accordion-slide]');

  this.multiple = this.container.data('multiple') || false;

  //Asign indicies
  this.slides.each(function(e) {
    var self = $(this);
    self.attr('data-id', e);
    self.find('[data-accordion-title]').attr('data-id', e);
  });

  //Event Handlers
  this.container.on('click', '[data-accordion-title]', this.changeSlide.bind(this));
}

Accordion.prototype = {
  changeSlide: function(e, b) {
    if(this.container === typeof undefined) return;
    var self = $(e.currentTarget);
    var index = self.data('id');
    if(typeof index === typeof undefined) return;
    this.setSlide(index);
  },

  getSlideByIndex: function(index) {
    return this.container.find('[data-accordion-slide][data-id="'+index+'"]');
  },

  setSlide: function(index) {
    var slide = this.getSlideByIndex(index);

    console.log(slide);

    if(slide.attr('data-expanded') == "true") {
      //Already expanded, just shrink this one
      slide.removeClass('is-expanded');
      slide.attr('data-expanded', false);
    } else {
      if(!this.multiple) {
        this.slides.removeClass('is-expanded');
        this.slides.attr('data-expanded', false);
      }
      slide.addClass('is-expanded');
      slide.attr('data-expanded', true);
    }

    this.onExpand(index, slide);
  },

  onExpand: function(index, slide) {

  }
}

$(document).ready(function() {
  $('[data-accordion]').each(function() {
    var self = $(this);
    var accordion = new Accordion(self);
    window.accordions = window.accordions || [];
    window.accordions.push(accordion);
  });
});

/*
 *  Ajax Cart
 *    Simple easy Ajax Cart.
 *
 *  Dependencies:
 *    scripts/tools/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function AjaxCart(container) {
  this.container = container;

  //Elements
  this.list = container.find('[data-ajax-cart-list]');
  this.loader = container.find('[data-ajax-cart-loader]');
  this.subtotal = container.find('[data-ajax-cart-subtotal]');
  this.cartCount = $('[data-ajax-cart-open] span');
  this.footer = container.find('[data-ajax-cart-footer]');
  this.empty = container.find('[data-ajax-cart-empty]');

  //Events
  $(document).on('onCartPending', this.onCartPending.bind(this));
  $(document).on('onCartFinished', this.onCartFinished.bind(this));
  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));
  $(document).on('onCartAdded', this.onCartAdded.bind(this));
  $(document).on('click', '[data-ajax-cart-open]', this.onOpen.bind(this));
  $(document).on('click', '[data-ajax-cart-remove-item]', this.onRemove);

  container.on('click', '[data-ajax-cart-close]', this.onClose.bind(this));


  //Finally print the existing cart data.
  //this.fetchAndPrint();
}

AjaxCart.prototype = {
  close: function() {
    this.container.removeClass('is-open');
    $(document.body).removeClass('is-ajax-cart-open');
    $('html').removeClass('is-ajax-cart-open');
  },

  open: function() {
    this.container.addClass('is-open');
    $(document.body).addClass('is-ajax-cart-open');
    $('html').addClass('is-ajax-cart-open');
  },

  isOpen: function() {
    return this.container.hasClass('is-open');
  },

  onRemove: function(e) {
    e.preventDefault();
    e.stopPropagation();
    var self = $(this);
    var index = self.attr('data-line-index');
    window.Cart.remove(index);
  },

  fetchAndPrint: function() {
    var o = {
      url: '/cart',
      data: {
        view: 'ajax'
      }
    };
    o.self = this;
    o.success = this.onPrintData.bind(o);
    o.error = this.onPrintError.bind(o);
    var request = $.ajax(o);
    o.request = request;

    this.lastRequest = request;
  },

  onPrintData: function(data) {
    //Take the raw cart data and print the correct information onto the ajax cart
    this.self.container.removeClass('is-loading');
    if(typeof data === typeof undefined || !data.length) {
      //TODO: Add an error handler
      return this.self.onPrintError.bind(this)(data);
    }

    this.self.list.html(data);
    this.self.container.find('[data-cart-quantity-selector]').each(function(e, i) {
      var selector = new CartQuantitySelector($(i));
    });
    this.self.list.trigger('onMoneyChange');
  },

  onPrintError: function(e, i, a, b) {
    console.log(e);
    console.log(i);
    console.log(a);
    console.log(b);
    this.self.list.html('<p>error</p>');
  },

  //Events
  onCartPending: function() {
    this.container.addClass('is-loading');
  },

  onCartFinished: function() {
  },

  onCartUpdate: function(e, newCart) {
    this.fetchAndPrint();
    this.subtotal.attr('data-money', newCart.total_price);
    this.subtotal.html(window.Currency.formatMoney(newCart.total_price));
    this.subtotal.trigger('onMoneyChange', newCart.total_price);
    this.cartCount.text(newCart.item_count);
    if (newCart.item_count < 1) {
      this.footer.hide();
      this.empty.show();
    }else{
      this.footer.show();
      this.empty.hide();
    }
  },

  onCartAdded: function(e) {
    this.open();
  },

  onClose: function(e) {
    e.stopPropagation();
    e.preventDefault();
    this.close();
  },

  onOpen: function(e) {
    e.stopPropagation();
    e.preventDefault();
    this.open();
  }
};

$(document).ready(function() {
  $('[data-ajax-cart]').each(function() {
    var self = $(this);
    window.ajaxCart = new AjaxCart(self);//Reference is loose, don't actually use.
  });
});

/*
 *  Currency Selector
 *    Scripts for a simple currency selector
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    js-cookie - js-cookie is required for saving currency selections.
 *    scripts/tools/currency.js - Required for currency stuff
 *    (Shopify Asset) /services/javascripts/currencies.js
 *
 *    window.Currency.currency - Must be set from Shopify using the {{ shop.currency }} tag.
 *    window.Currency.format - Must be set from {{ shop.money_format }}
 *
 *  Events:
 *    onCurrencyChange(e:Event, newCurrency:String)
 *      Fired when the currency is changed.
 *
 *  Version:
 *    1.0.0 - 2018/02/09
 */
window.Currency = window.Currency || {}
window.Currency.moneyFormats = window.Currency.moneyFormats || {
  "USD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} USD"
  },
  "EUR":{
    "money_format":"&euro;{{amount}}",
    "money_with_currency_format":"&euro;{{amount}} EUR"
  },
  "GBP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} GBP"
  },
  "CAD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} CAD"
  },
  "ALL":{
    "money_format":"Lek {{amount}}",
    "money_with_currency_format":"Lek {{amount}} ALL"
  },
  "DZD":{
    "money_format":"DA {{amount}}",
    "money_with_currency_format":"DA {{amount}} DZD"
  },
  "AOA":{
    "money_format":"Kz{{amount}}",
    "money_with_currency_format":"Kz{{amount}} AOA"
  },
  "ARS":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} ARS"
  },
  "AMD":{
    "money_format":"{{amount}} AMD",
    "money_with_currency_format":"{{amount}} AMD"
  },
  "AWG":{
    "money_format":"Afl{{amount}}",
    "money_with_currency_format":"Afl{{amount}} AWG"
  },
  "AUD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} AUD"
  },
  "BBD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} Bds"
  },
  "AZN":{
    "money_format":"m.{{amount}}",
    "money_with_currency_format":"m.{{amount}} AZN"
  },
  "BDT":{
    "money_format":"Tk {{amount}}",
    "money_with_currency_format":"Tk {{amount}} BDT"
  },
  "BSD":{
    "money_format":"BS${{amount}}",
    "money_with_currency_format":"BS${{amount}} BSD"
  },
  "BHD":{
    "money_format":"{{amount}}0 BD",
    "money_with_currency_format":"{{amount}}0 BHD"
  },
  "BYR":{
    "money_format":"Br {{amount}}",
    "money_with_currency_format":"Br {{amount}} BYR"
  },
  "BZD":{
    "money_format":"BZ${{amount}}",
    "money_with_currency_format":"BZ${{amount}} BZD"
  },
  "BTN":{
    "money_format":"Nu {{amount}}",
    "money_with_currency_format":"Nu {{amount}} BTN"
  },
  "BAM":{
    "money_format":"KM {{amount_with_comma_separator}}",
    "money_with_currency_format":"KM {{amount_with_comma_separator}} BAM"
  },
  "BRL":{
    "money_format":"R$ {{amount_with_comma_separator}}",
    "money_with_currency_format":"R$ {{amount_with_comma_separator}} BRL"
  },
  "BOB":{
    "money_format":"Bs{{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs{{amount_with_comma_separator}} BOB"
  },
  "BWP":{
    "money_format":"P{{amount}}",
    "money_with_currency_format":"P{{amount}} BWP"
  },
  "BND":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} BND"
  },
  "BGN":{
    "money_format":"{{amount}} Ð»Ð²",
    "money_with_currency_format":"{{amount}} Ð»Ð² BGN"
  },
  "MMK":{
    "money_format":"K{{amount}}",
    "money_with_currency_format":"K{{amount}} MMK"
  },
  "KHR":{
    "money_format":"KHR{{amount}}",
    "money_with_currency_format":"KHR{{amount}}"
  },
  "KYD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} KYD"
  },
  "XAF":{
    "money_format":"FCFA{{amount}}",
    "money_with_currency_format":"FCFA{{amount}} XAF"
  },
  "CLP":{
    "money_format":"${{amount_no_decimals}}",
    "money_with_currency_format":"${{amount_no_decimals}} CLP"
  },
  "CNY":{
    "money_format":"&#165;{{amount}}",
    "money_with_currency_format":"&#165;{{amount}} CNY"
  },
  "COP":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} COP"
  },
  "CRC":{
    "money_format":"&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format":"&#8353; {{amount_with_comma_separator}} CRC"
  },
  "HRK":{
    "money_format":"{{amount_with_comma_separator}} kn",
    "money_with_currency_format":"{{amount_with_comma_separator}} kn HRK"
  },
  "CZK":{
    "money_format":"{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format":"{{amount_with_comma_separator}} K&#269;"
  },
  "DKK":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"kr.{{amount_with_comma_separator}}"
  },
  "DOP":{
    "money_format":"RD$ {{amount}}",
    "money_with_currency_format":"RD$ {{amount}}"
  },
  "XCD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"EC${{amount}}"
  },
  "EGP":{
    "money_format":"LE {{amount}}",
    "money_with_currency_format":"LE {{amount}} EGP"
  },
  "ETB":{
    "money_format":"Br{{amount}}",
    "money_with_currency_format":"Br{{amount}} ETB"
  },
  "XPF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} XPF"
  },
  "FJD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"FJ${{amount}}"
  },
  "GMD":{
    "money_format":"D {{amount}}",
    "money_with_currency_format":"D {{amount}} GMD"
  },
  "GHS":{
    "money_format":"GH&#8373;{{amount}}",
    "money_with_currency_format":"GH&#8373;{{amount}}"
  },
  "GTQ":{
    "money_format":"Q{{amount}}",
    "money_with_currency_format":"{{amount}} GTQ"
  },
  "GYD":{
    "money_format":"G${{amount}}",
    "money_with_currency_format":"${{amount}} GYD"
  },
  "GEL":{
    "money_format":"{{amount}} GEL",
    "money_with_currency_format":"{{amount}} GEL"
  },
  "HNL":{
    "money_format":"L {{amount}}",
    "money_with_currency_format":"L {{amount}} HNL"
  },
  "HKD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"HK${{amount}}"
  },
  "HUF":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} Ft"
  },
  "ISK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr ISK"
  },
  "INR":{
    "money_format":"Rs. {{amount}}",
    "money_with_currency_format":"Rs. {{amount}}"
  },
  "IDR":{
    "money_format":"{{amount_with_comma_separator}}",
    "money_with_currency_format":"Rp {{amount_with_comma_separator}}"
  },
  "ILS":{
    "money_format":"{{amount}} NIS",
    "money_with_currency_format":"{{amount}} NIS"
  },
  "JMD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} JMD"
  },
  "JPY":{
    "money_format":"&#165;{{amount_no_decimals}}",
    "money_with_currency_format":"&#165;{{amount_no_decimals}} JPY"
  },
  "JEP":{
    "money_format":"&pound;{{amount}}",
    "money_with_currency_format":"&pound;{{amount}} JEP"
  },
  "JOD":{
    "money_format":"{{amount}}0 JD",
    "money_with_currency_format":"{{amount}}0 JOD"
  },
  "KZT":{
    "money_format":"{{amount}} KZT",
    "money_with_currency_format":"{{amount}} KZT"
  },
  "KES":{
    "money_format":"KSh{{amount}}",
    "money_with_currency_format":"KSh{{amount}}"
  },
  "KWD":{
    "money_format":"{{amount}}0 KD",
    "money_with_currency_format":"{{amount}}0 KWD"
  },
  "KGS":{
    "money_format":"Ð»Ð²{{amount}}",
    "money_with_currency_format":"Ð»Ð²{{amount}}"
  },
  "LVL":{
    "money_format":"Ls {{amount}}",
    "money_with_currency_format":"Ls {{amount}} LVL"
  },
  "LBP":{
    "money_format":"L&pound;{{amount}}",
    "money_with_currency_format":"L&pound;{{amount}} LBP"
  },
  "LTL":{
    "money_format":"{{amount}} Lt",
    "money_with_currency_format":"{{amount}} Lt"
  },
  "MGA":{
    "money_format":"Ar {{amount}}",
    "money_with_currency_format":"Ar {{amount}} MGA"
  },
  "MKD":{
    "money_format":"Ð´ÐµÐ½ {{amount}}",
    "money_with_currency_format":"Ð´ÐµÐ½ {{amount}} MKD"
  },
  "MOP":{
    "money_format":"MOP${{amount}}",
    "money_with_currency_format":"MOP${{amount}}"
  },
  "MVR":{
    "money_format":"Rf{{amount}}",
    "money_with_currency_format":"Rf{{amount}} MRf"
  },
  "MXN":{
    "money_format":"$ {{amount}}",
    "money_with_currency_format":"$ {{amount}} MXN"
  },
  "MYR":{
    "money_format":"RM{{amount}} MYR",
    "money_with_currency_format":"RM{{amount}} MYR"
  },
  "MUR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} MUR"
  },
  "MDL":{
    "money_format":"{{amount}} MDL",
    "money_with_currency_format":"{{amount}} MDL"
  },
  "MAD":{
    "money_format":"{{amount}} dh",
    "money_with_currency_format":"Dh {{amount}} MAD"
  },
  "MNT":{
    "money_format":"{{amount_no_decimals}} &#8366",
    "money_with_currency_format":"{{amount_no_decimals}} MNT"
  },
  "MZN":{
    "money_format":"{{amount}} Mt",
    "money_with_currency_format":"Mt {{amount}} MZN"
  },
  "NAD":{
    "money_format":"N${{amount}}",
    "money_with_currency_format":"N${{amount}} NAD"
  },
  "NPR":{
    "money_format":"Rs{{amount}}",
    "money_with_currency_format":"Rs{{amount}} NPR"
  },
  "ANG":{
    "money_format":"&fnof;{{amount}}",
    "money_with_currency_format":"{{amount}} NA&fnof;"
  },
  "NZD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} NZD"
  },
  "NIO":{
    "money_format":"C${{amount}}",
    "money_with_currency_format":"C${{amount}} NIO"
  },
  "NGN":{
    "money_format":"&#8358;{{amount}}",
    "money_with_currency_format":"&#8358;{{amount}} NGN"
  },
  "NOK":{
    "money_format":"kr {{amount_with_comma_separator}}",
    "money_with_currency_format":"kr {{amount_with_comma_separator}} NOK"
  },
  "OMR":{
    "money_format":"{{amount_with_comma_separator}} OMR",
    "money_with_currency_format":"{{amount_with_comma_separator}} OMR"
  },
  "PKR":{
    "money_format":"Rs.{{amount}}",
    "money_with_currency_format":"Rs.{{amount}} PKR"
  },
  "PGK":{
    "money_format":"K {{amount}}",
    "money_with_currency_format":"K {{amount}} PGK"
  },
  "PYG":{
    "money_format":"Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"Gs. {{amount_no_decimals_with_comma_separator}} PYG"
  },
  "PEN":{
    "money_format":"S/. {{amount}}",
    "money_with_currency_format":"S/. {{amount}} PEN"
  },
  "PHP":{
    "money_format":"&#8369;{{amount}}",
    "money_with_currency_format":"&#8369;{{amount}} PHP"
  },
  "PLN":{
    "money_format":"{{amount_with_comma_separator}} zl",
    "money_with_currency_format":"{{amount_with_comma_separator}} zl PLN"
  },
  "QAR":{
    "money_format":"QAR {{amount_with_comma_separator}}",
    "money_with_currency_format":"QAR {{amount_with_comma_separator}}"
  },
  "RON":{
    "money_format":"{{amount_with_comma_separator}} lei",
    "money_with_currency_format":"{{amount_with_comma_separator}} lei RON"
  },
  "RUB":{
    "money_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format":"&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
  },
  "RWF":{
    "money_format":"{{amount_no_decimals}} RF",
    "money_with_currency_format":"{{amount_no_decimals}} RWF"
  },
  "WST":{
    "money_format":"WS$ {{amount}}",
    "money_with_currency_format":"WS$ {{amount}} WST"
  },
  "SAR":{
    "money_format":"{{amount}} SR",
    "money_with_currency_format":"{{amount}} SAR"
  },
  "STD":{
    "money_format":"Db {{amount}}",
    "money_with_currency_format":"Db {{amount}} STD"
  },
  "RSD":{
    "money_format":"{{amount}} RSD",
    "money_with_currency_format":"{{amount}} RSD"
  },
  "SCR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} SCR"
  },
  "SGD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} SGD"
  },
  "SYP":{
    "money_format":"S&pound;{{amount}}",
    "money_with_currency_format":"S&pound;{{amount}} SYP"
  },
  "ZAR":{
    "money_format":"R {{amount}}",
    "money_with_currency_format":"R {{amount}} ZAR"
  },
  "KRW":{
    "money_format":"&#8361;{{amount_no_decimals}}",
    "money_with_currency_format":"&#8361;{{amount_no_decimals}} KRW"
  },
  "LKR":{
    "money_format":"Rs {{amount}}",
    "money_with_currency_format":"Rs {{amount}} LKR"
  },
  "SEK":{
    "money_format":"{{amount_no_decimals}} kr",
    "money_with_currency_format":"{{amount_no_decimals}} kr SEK"
  },
  "CHF":{
    "money_format":"SFr. {{amount}}",
    "money_with_currency_format":"SFr. {{amount}} CHF"
  },
  "TWD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TWD"
  },
  "THB":{
    "money_format":"{{amount}} &#xe3f;",
    "money_with_currency_format":"{{amount}} &#xe3f; THB"
  },
  "TZS":{
    "money_format":"{{amount}} TZS",
    "money_with_currency_format":"{{amount}} TZS"
  },
  "TTD":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}} TTD"
  },
  "TND":{
    "money_format":"{{amount}}",
    "money_with_currency_format":"{{amount}} DT"
  },
  "TRY":{
    "money_format":"{{amount}}TL",
    "money_with_currency_format":"{{amount}}TL"
  },
  "UGX":{
    "money_format":"Ush {{amount_no_decimals}}",
    "money_with_currency_format":"Ush {{amount_no_decimals}} UGX"
  },
  "UAH":{
    "money_format":"â‚´{{amount}}",
    "money_with_currency_format":"â‚´{{amount}} UAH"
  },
  "AED":{
    "money_format":"Dhs. {{amount}}",
    "money_with_currency_format":"Dhs. {{amount}} AED"
  },
  "UYU":{
    "money_format":"${{amount_with_comma_separator}}",
    "money_with_currency_format":"${{amount_with_comma_separator}} UYU"
  },
  "VUV":{
    "money_format":"${{amount}}",
    "money_with_currency_format":"${{amount}}VT"
  },
  "VEF":{
    "money_format":"Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format":"Bs. {{amount_with_comma_separator}} VEF"
  },
  "VND":{
    "money_format":"{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format":"{{amount_no_decimals_with_comma_separator}} VND"
  },
  "XBT":{
    "money_format":"{{amount_no_decimals}} BTC",
    "money_with_currency_format":"{{amount_no_decimals}} BTC"
  },
  "XOF":{
    "money_format":"CFA{{amount}}",
    "money_with_currency_format":"CFA{{amount}} XOF"
  },
  "ZMW":{
    "money_format":"K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format":"ZMW{{amount_no_decimals_with_comma_separator}}"
  }
};
window.Currency.convertedFormat = window.Currency.convertedFormat || (
  (function(e) {
    var k = Object.keys(e);
    for(var i = 0; i < k.length; i++) {
      if(e[k[i]] == window.Currency.format) return k[i];
    }
    return "money_format";
  })(window.Currency.moneyFormats[window.Currency.currency])
);

window.Currency.updatePrices = window.Currency.updatePrices || function(newCurrency) {
  var currency = window.Currency.currentCurrency || window.Currency.currency;
  var newFormat = window.Currency.moneyFormats[currency][window.Currency.convertedFormat];

  $('[data-currency]').each(function() {
    var self = $(this);
    if(!self.is('[data-money]')) return;
    var money = self.attr('data-money');
    if(!money || !money.length) {
      self.html('');
      return;
    }
    if(typeof window.Currency.convert === typeof undefined) return;

    var moneyConverted;
    if(currency == window.Currency.currency) {
      //No need to convert
      moneyConverted = money;
    } else {
      //Convert
      moneyConverted = window.Currency.convert(money, window.Currency.currency, currency);
    }

    //Change display
    self.html(window.Currency.formatMoney(moneyConverted, newFormat));
  });
};

window.Currency.getMoney = function(money) {
  var currency = window.Currency.currentCurrency || window.Currency.currency;
  return window.Currency.convert(money, window.Currency.currency, currency);
}

//Currency Converter
var CURRENCY_COOKIE_NAME = 'currency';

$(document).on('change', '[data-currency-selector]', function(e) {
  var self = $(this);
  var val = self.val();
  self.trigger('onCurrencyChange', val);
});

function addCurrencyListener() {
  $(document).on('onCurrencyChange', function(e, newVal) {
    //Validate currency
    if(typeof newVal === typeof undefined) return;
    if(typeof window.Currency.moneyFormats === typeof undefined) return;
    if(typeof window.Currency.moneyFormats[newVal] === typeof undefined) return;
    window.Currency.currentCurrency = newVal;
    var format = window.Currency.moneyFormats[newVal];
    console.log("Currency set to " + newVal);

    //Check if already selected.
    $('[data-currency-selector]').val(newVal);

    //Save currency selection
    if(typeof Cookies !== typeof undefined) {
      Cookies.set(CURRENCY_COOKIE_NAME, newVal);
    } else if($.cookie !== typeof undefined) {
      $.cookie(CURRENCY_COOKIE_NAME, newVal);
    }

    window.Currency.updatePrices();
  });

  $(document).on('onMoneyChange', function(e, newVal) {
    window.Currency.updatePrices();
  });
}

//Check the cookie
function checkCurrencyCookie() {
  if(typeof Cookies !== typeof undefined && Cookies.get(CURRENCY_COOKIE_NAME)) {
    var currency = Cookies.get(CURRENCY_COOKIE_NAME);
    $(document).trigger('onCurrencyChange', currency);
  } else if(typeof $.cookie !== typeof undefined && $.cookie(CURRENCY_COOKIE_NAME)) {
    var currency = $.cookie(CURRENCY_COOKIE_NAME);
    $(document).trigger('onCurrencyChange', currency);
  }
}

//Check existing currency selection
$(document).ready(function() {
  //Due to an issue I was having with certain elements overriding my beautiful
  //events, I've had to move this listener to here, I don't like it but it's
  //a sacrifice that needed to be done.
  addCurrencyListener();
  checkCurrencyCookie();
});
addCurrencyListener();

/*
 *  Quantity Selector
 *    Quantity Selector. Please note that this has no logic and is designed to
 *    be implemented by a subclass (e.g. a Product Page Quantity Selector, or
 *    a Cart Page Quantity Selector)
 *
 *  Version:
 *    1.0.0 - 2018/07/29
 */
function QuantitySelector(container) {
  this.container = container;

  //Elements
  this.addButton = container.find('[data-quantity-selector-plus]');
  this.minusButton = container.find('[data-quantity-selector-minus]');
  this.input = container.find('[data-quantity-selector-input]');

  //Listeners
  container.on('click', '[data-quantity-selector-minus]', this.onMinusClick.bind(this) );
  container.on('click', '[data-quantity-selector-plus]', this.onAddClick.bind(this) );
  container.on('blur', '[data-quantity-selector-input]', this.onBlur.bind(this));

  //Internals
  this.fixIntegers();
  this.previousValue = this.getValue();
  this.updateButtonStates();
}

QuantitySelector.prototype = {
  getValue: function() {
    var v = parseInt(this.input.val());
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;
    return v;
  },

  getMin: function() {
    return this.input.attr('data-quantity-selector-input-min') || Number.NEGATIVE_INFINITY;
  },

  getMax: function() {
    return this.input.attr('data-quantity-selector-input-max') || Number.INFINITY;
  },

  onMinusClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(-1);
  },

  onAddClick: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.modify(1);
  },

  onBlur: function() {
    this.fixIntegers();
    var val = this.getValue();
    this.set(val);
  },

  modify: function(amt) {
    this.fixIntegers();
    var val = this.getValue();
    val += amt;
    this.set(val);
  },

  set: function(v) {
    if(isNaN(v)) v = 0;
    if(!isFinite(v)) v = 0;
    if(v < this.getMin()) v = this.getMin();
    if(v > this.getMax()) v = this.getMax();
    if(!isFinite(v)) v = 0;

    this.input.val(v);

    //Update the button states
    this.updateButtonStates();

    //Trigger an update event?
    if(this.previousValue == v) return;

    if(v > this.previousValue) {
      this.onAdd(v);
    } else {
      this.onMinus(v);
    }
    this.onChange(v);
  },

  fixIntegers: function() {
    var v = this.getValue();
    if(parseInt(this.input.val()) != v) {
      this.input.val(v);
    }
  },

  updateButtonStates: function() {
    var v = this.getValue();
    if(v == this.getMin()) {
      this.minusButton.attr('disabled', 'disabled');
    } else {
      this.minusButton.removeAttr('disabled');
    }

    if(v == this.getMax()) {
      this.addButton.attr('disabled', 'disabled');
    } else {
      this.addButton.removeAttr('disabled');
    }
  },

  //Events (you can sub these methods)
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {}
};

/*
 *  Swatch
 *    Product Swatch Controls (does not handle standard variants)
 *
 *  Dependencies:
 *    snippets/product-swatches.liquid
 *    scripts/objects/variant-selector.js
 *    jQuery
 *
 *  Version:
 *    1.1.0 - 2015/06/18
 */
window.swatch = {
  setVariantFromSwatch: function(el, value) {
    //Triggers a standard variant change based on a swatch
    var position = el.attr('data-swatch-position');

    var currentSelection = $('[data-variant-option]:selected');

    var selector = '[data-variant-option]';

    //Ok so I was running into a problem regarding multiple levels of variants
    //And this is caused by non standard variants
    //e.g. if a product has the variants:
    // Material Cloth, Color Red
    // Material Cloth, Color Blue
    // Material Silk, Color Red
    // Material Silk, Color Green
    //It will show the color green even if the material is currently cloth, and
    //Will fail to select the variant if there's.. yada yada etc etc basically
    //we need to only show variant subs for variants of top level-ness
    var optionCount = currentSelection.attr('data-option-count');
    var target;

    for(var i = 1; i <= optionCount; i++) {
      var selectorValue;
      if(i == position) {
        //This is the value we've updated.
        selectorValue = value;
      } else {
        var existingValue = currentSelection.attr('data-option'+i);
        if(typeof existingValue === typeof undefined) continue;
        selectorValue = existingValue;
      }

      var selectorTemp = ""+selector;//Temporary "previous" storage
      selector += '[data-option'+i+'="'+selectorValue+'"]';
      //Ok now we're going to check if the variant we're after exists
      var target = $(selector);
      if(!target.length) {
        //Okay so the selector we're targetting isn't valid for the new selection
        //So that means that we have to just find the first of its kind
        selector = selectorTemp + '[data-option'+i+']:first';
        target = $(selector);
      }
    }

    //Find the variant ID based from the selection
    var targetValue = target.val();
    var targetData = window.VariantSelector.getVariantData(targetValue);
    if(typeof targetData === typeof undefined) return;
    $(document).trigger('onVariantChange',[targetValue,targetData]);
  },

  updateAvailableSwatches: function(variant) {
    //Now decide what we're going to hide and show in terms of swatches.
    var option = $('[data-variant-option][value="'+variant+'"]');
    var optionCount = option.attr('data-option-count');
    var jsonElement = $('[data-product-json]');
    if(!jsonElement.length) return;
    var data = JSON.parse( jsonElement.html() );
    var selectedVariant;
    for(var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if(v.id != variant) continue;
      selectedVariant = v;
      break;
    }
    if(!selectedVariant) return;

    //Begin hiding
    $('[data-swatch]').addClass('is-hidden');
    $('[data-swatch-selector] option').attr('disabled', 'disabled');

    //Top level are always available
    $('[data-swatch][data-swatch-position="1"]').removeClass('is-hidden');
    $('[data-swatch-selector][data-swatch-position="1"] option').removeAttr('disabled');



    for(var i = 2; i <= optionCount; i++) {
      //Given the selected previous level, what options for *this* level are available?
      var prevOption = selectedVariant["option"+(i-1)];
      var allowedOptionsForThisLevel = [];
      for(var x = 0; x < data.variants.length; x++) {
        var v = data.variants[x];
        var n = v["option"+i];
        if(allowedOptionsForThisLevel.indexOf(n) !== -1) continue;
        if(v["option"+(i-1)] != prevOption) continue;
        allowedOptionsForThisLevel.push(n);
      }

      for(var x = 0; x < allowedOptionsForThisLevel.length; x++) {
        var ao = allowedOptionsForThisLevel[x];
        $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+ao+'"]').removeClass('is-hidden');
        $('[data-swatch-selector][data-swatch-position="'+i+'"] [value="'+ao+'"]').removeAttr('disabled');
      }
    }
  }
};

//Swatch Listeners
$(document).on('click', '[data-swatch]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.attr('data-value'));
});

$(document).on('change', '[data-swatch-selector]', function(e) {
  var self = $(this);
  window.swatch.setVariantFromSwatch(self, self.val());
});

$(document).ready(function() {
  var currentSelection = $('[data-variant-option]:selected');
  window.swatch.updateAvailableSwatches(currentSelection.attr('value'));
});

//Variant Listeners
$(document).on('onVariantChange', function(e, variant, variantData) {
  var option = $('[data-variant-option][value="'+variant+'"]');
  var optionCount = option.attr('data-option-count');

  $('[data-swatch]').removeClass('is-selected');

  //Now decide what we're going to hide and show in terms of swatches.
  window.swatch.updateAvailableSwatches(variant);

  for(var i = 1; i <= optionCount; i++) {
    var val = option.attr('data-option'+i);
    $('[data-swatch][data-swatch-position="'+i+'"][data-value="'+val+'"]').addClass('is-selected');
    $('[data-swatch-selector][data-swatch-position="'+i+'"]').val(val);
    $('[data-swatch-value][data-swatch-position="'+i+'"]').html(variantData['option'+i]);
  }
});

/*
 *  Variant Selector
 *    Provides basic functionality for the variant selector
 *
 *  Dependencies:
 *    scripts/tools/query.js
 *    scripts/tools/language.js - Required for messasges.
 *    scripts/tools/currency.js - Required for money.
 *    snippets/variant-selector.liquid
 *
 *  Version:
 *    2.0.0 - 2018/07/30
 */
window.Language.required('products.product.add_to_cart');
window.Language.required('products.product.sold_out');

//Common Functions
window.VariantSelector = window.VariantSelector || {};
window.VariantSelector.getVariantData = window.VariantSelector.getVariantData || (function(variant) {
  var data = JSON.parse( $('[data-product-json]').html() );
  //Get the variant value
  var variantData;
  for(var i = 0; i < data.variants.length; i++) {
    var v = data.variants[i];
    if(v.id != variant) continue;
    variantData = v;
    break;
  }
  return variantData;
});



//Track changes to the selector
$(document).on('change', '[data-product-select]', function(e) {
  var self = $(this);
  var variant = self.val();
  var variantData = window.VariantSelector.getVariantData(variant);
  if(typeof variantData === typeof undefined) return;

  $(document).trigger('onVariantChange',[variant,variantData]);
});

//Track events
$(document).on('onVariantChange', function(e, variant, variantData) {
  //Update Selectors
  $('[data-product-select]').val(variant);

  //Update the URL
  window.queryTools.setValue('variant', variant);

  //Update product details
  var price = variantData.price;
  var moneyElement = $('[data-product-money]');
  moneyElement.attr('data-money', price);
  moneyElement.html(window.Currency.formatMoney(price));
  moneyElement.trigger('onMoneyChange', price);

  //Compare at price. Please note this logic is replicated in the
  //product-pricing.liquid snippet, please ensure all logic changes made here
  //are replicated there.
  var comparePrice = variantData.compare_at_price;
  var compareMoneyElement = $('[data-product-compare-money]');
  compareMoneyElement.attr('data-money', comparePrice);
  if(comparePrice > price && variantData.available) {
    compareMoneyElement.html(window.Currency.formatMoney(comparePrice));
    compareMoneyElement.trigger('onMoneyChange', comparePrice);
  } else {
    compareMoneyElement.html('');
  }

  //Update Add To Cart Button
  var addToCart = $('[data-add-to-cart]');
  if(variantData.available) {
    addToCart.removeAttr('disabled');
    addToCart.html(window.Language.get('products.product.add_to_cart'));
  } else {
    addToCart.attr('disabled', 'disabled');
    addToCart.html(window.Language.get('products.product.sold_out'));
    moneyElement.html('<span class="o-product-pricing__money__soldout">'+window.Language.get('products.product.sold_out')+'</span>');
  }

  //Update sku
  var sku = $('[data-product-sku]');
  sku.text(variantData.sku);
  
  // BOLD QB
  var variantId = variantData.id;
  if(typeof shappify_update_message == 'function'){
    shappify_update_message(null, variantId) 
  }
  // BOLD QB
});

//History Event
window.onpopstate = function(event) {
  var t = event.target;
  var o = window.queryTools.decodeSearch(t.location.search);

  if(typeof o.variant === typeof undefined || !o.variant.length) return;
  if($('[data-product-select]').val() == o.variant) return;

  var variantData = window.VariantSelector.getVariantData(o.variant);
  if(typeof variantData === typeof undefined) return;

  $(document).trigger('onVariantChange',[o.variant,variantData]);
};



/*
 *  Product Page Quantity Selector
 *    Quantity Selector for a product page.
 *
 *  Dependencies:
 *    scripts/objects/_quantity-selector.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function ProductPageQuantitySelector(container) {
  QuantitySelector.call(this, container);
}

//Inherit
ProductPageQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), ProductPageQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {
  },
});

//Finalize Inheritence
ProductPageQuantitySelector.prototype.constructor = ProductPageQuantitySelector;

//TODO: Add support for max that can be added to the cart, this is limited due
//to the fact that the product JSON does not contain the max inventory (maybe a
//good idea)

//Attach
$(document).ready(function() {
  $('[data-product-page-quantity-selector]').each(function() {
    var self = $(this);
    new ProductPageQuantitySelector(self);
  });
});

/*
 *  Cart Quantity Selector
 *    Quantity selector for use on the cart line items
 *
 *  Dependencies:
 *    scripts/objects/_quantity-selector.js
 *    scripts/tools/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function CartQuantitySelector(container) {
  QuantitySelector.call(this, container);

  this.lineItemId = this.container.attr('data-line-item-id');
  this.lineItemIndex = this.container.attr('data-line-item-index');
}

//Inherit
CartQuantitySelector.prototype = Object.assign(Object.assign(Object.assign({}, QuantitySelector.prototype), CartQuantitySelector.prototype), {
  onAdd: function() {},
  onMinus: function() {},
  onChange: function() {
    var value = this.getValue();
    if(value == 0) {
      //Remove from the Cart
      window.Cart.remove(this.lineItemIndex);
    } else {
      window.Cart.update(this.lineItemIndex, value);
    }
  },
});

//Finalize Inheritence
CartQuantitySelector.prototype.constructor = CartQuantitySelector;

//TODO: Add support for max that can be added to the cart, this is limited due
//to the fact that the product JSON does not contain the max inventory (maybe a
//good idea)

//Attach
$(document).ready(function() {
  $('[data-cart-quantity-selector]').each(function() {
    var self = $(this);
    window.cartQuantitySelector = new CartQuantitySelector(self);
  });
});


/*================ Components ================*/
/*** Import Filters ***/
function AjaxCollectionFilter(handle, collection) {
  this.handle = handle;
  this.collection = collection;
}

AjaxCollectionFilter.prototype = {
  getSettings: function() {
    //Return a list (either array or object) of all this filters' settings.
  },

  getSetting: function(key) {
    //Returns the setting specified by key (it's current value)
  },

  setSetting: function(key, value) {
    //Set the value at key with the value; value
  },

  setSettings: function(settings) {
    //Same as above but for all settings at once
  },

  filter: function(product, variant) {
    //Your custom filter may super this method.
    //Retrurn true to keep this product, false to remove.
    return true;
  },

  init: function(settings) {
    //Init with the default settings, shouldn't be sub called, designed to use
    //whatever settings are defined at a collection level.
    if(typeof settings === typeof undefined || !settings) return;
    this.setSettings(settings);
  }
};

/*
 *  AjaxCollectionTagFilter
 *    Designed to take in an array of tags to filter the products by.
 *    Can be used in either AND or OR operation.
 *
 *    IMPORTANT NOTE!!!!! ALL TAGS WILL BE CONVERTED TO LOWERCASE!!
 *
 *    AND Example:
 *      Product A has tags "Red", "Green" and "Blue"
 *      Product B has tags "Red", "Orange", "Blue" and "Brown"
 *      Results when setting the filter tags to...:
 *        ["Red", "Green"] = Product A will show, not B
 *        [ "Red" ] = Both A and B will show
 *        [ "Red", "Blue" ] = Both A and B
 *        [ "Brown" ] = Only B will show
 *        [ "Green", "Orange" ] = Neither will show
 *
 *    OR Example:
 *      Same example as above except results will be...
 *        ["Red", "Green"] = Both A and B will show
 *        [ "Red" ] = Both A and B will show
 *        [ "Red", "Blue" ] = Both A and B
 *        [ "Brown" ] = Only B will show
 *        [ "Green", "Orange" ] = Both A and B will show
 *        [ "Purple" ] = Neither will show
 */
function AjaxCollectionTagFilter(handle, collection, operation, tags) {
  AjaxCollectionFilter.call(this, handle, collection);

  //Params Default
  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof tags === typeof undefined) tags = [];

  //Tag arrays
  this.tags = tags;
  this.operation = operation;//Can be AND or OR.
}

//Extend the base filter object.
AjaxCollectionTagFilter.prototype = Object.assign(AjaxCollectionTagFilter.prototype, AjaxCollectionFilter.prototype);
AjaxCollectionTagFilter.prototype = Object.assign(AjaxCollectionTagFilter.prototype, {

  //Set Operation, can be either AND or OR, used for tag comparison
  setOperation: function(and_or_or) {
    this.operation = and_or_or;
    this.collection.onFilterUpdate();
  },


  //Add a tag to this filter, also forces an update
  addTag: function(tag) {
    tag = tag.toLowerCase();
    if(this.tags.indexOf(tag) !== -1) return;
    this.tags.push(tag);

    this.collection.onFilterUpdate();
  },

  //Remove a tag from this filter, forces an update
  removeTag: function(tag) {
    tag = tag.toLowerCase();
    var index = this.tags.indexOf(tag);
    if(index === -1) return;
    this.tags.splice(index, 1);

    this.collection.onFilterUpdate();
  },

  //Get all settings, in this case we're returning an array of tags that this
  //filter is.. filtering by.
  getSettings: function() {
    return this.tags;
  },

  //Get an individual setting (tag, either true or false if restricted)
  getSetting: function(tag) {
    tag = tag.toLowerCase();
    if(typeof tag === typeof undefined) return this.tags;
    return this.tags.indexOf(tag) !== -1;
  },

  //Set a setting, if true it will add that tag to this filter, if false it will
  //remove it.
  setSetting: function(key, value) {
    if(value) return this.addTag(key);
    this.removeTag(key);
  },

  //Set an array of tags (or pass a single tag) and it will force an update
  setSettings: function(settingSet) {
    if(!Array.isArray(settingSet)) settingSet = [ settingSet ];
    this.tags = settingSet;
    this.collection.onFilterUpdate();
  },

  //Filtering Function, called for every product and variant that is going to be
  //printed.
  filter: function(product, variant) {
    //If we're not filtering by any tags, just return
    if(!this.tags.length) return true;//No filtering

    //For each tag in this filter...
    var hasAnyTag = false;
    for(var i = 0; i < this.tags.length; i++) {
      //For each tag in product...
      var filterTag = this.tags[i];
      var filterTagLower = filterTag.toLowerCase();
      var hasThisTag = false;

      for(var x = 0; x < product.tags.length; x++) {
        var productTag = product.tags[x];
        var productTagLower = productTag.toLowerCase();
        if(filterTagLower != productTagLower) continue;//Case insensitive.
        hasThisTag = true;
        hasAnyTag = true;
        break;
      }

      //Now the magic
      if(this.operation == "AND" && !hasThisTag) {
        //Since AND Requires every one of this filters' tags, we can safely exit
        //if it's missing even a single tag
        return false;
      } else if(this.operation == "OR" && hasThisTag) {
        //Since OR allows us to have any of the tags we can safely exit!
        return true;
      }
    }

    //Since the above methods are inverted for OR vs AND, we need to change our
    //default return method.

    //OR Above will return for any tag, but the default needs to be false
    //AND Above will return false if it's missing any tag, but the default
    //(all tags) must be true
    if(this.operation == "AND") {
      return true;
    } else if(this.operation == "OR") {
      return false;
    }
  }
});

function AjaxCollectionGroupFilter(handle, collection, operation, filters) {
  AjaxCollectionFilter.call(this, handle, collection);

  if(typeof operation === typeof undefined) operation = "AND";
  if(typeof filters === typeof undefined) filters = [];

  this.operation = operation;//Operation
  this.filters = filters;//Sub filters
}

AjaxCollectionGroupFilter.prototype = Object.assign({}, AjaxCollectionFilter.prototype);

AjaxCollectionGroupFilter.prototype.addFilter = function(filter) {
  if(this.filters.indexOf(filter) === -1) return;
  this.filters.push(filter);
  this.collection.onFilterUpdate();
}

AjaxCollectionGroupFilter.prototype.removeFilter = function(filter) {
  var index = this.filters.indexOf(filter);
  if(index === -1) return;
  this.filters.splice(index, 1);

  this.collection.onFilterUpdate();
}

AjaxCollectionGroupFilter.prototype.filter = function(product, variant) {
  //No Filters?
  if(!this.filters.length) return true;

  for(var i = 0; i < this.filters.length; i++) {
    var filter = this.filters[i];
    var result = filter.filter(product,variant);

    //Now the magic
    if(this.operation == "AND" && !result) {
      return false;
    } else if(this.operation == "OR" && result) {
      return true;
    }
  }

  //Default return (changes depending on OR vs AND)
  if(this.operation == "AND") {
    return true;
  } else if(this.operation == "OR") {
    return false;
  }
}


/*** Import Facets ***/
function AjaxCollectionFacet(collection, filter, container, title) {
  this.collection = collection;
  this.filter = filter;
  this.container = container;
  this.title = title;
}

AjaxCollectionFacet.prototype = {
  getCollection: function() {return this.collection;},
  getFilter: function() {return this.filter;},

  print: function() {
    var x = '';
    if(this.title) {
      x += '<span class="c-faceted-nav__title">';
      x += this.title.escapeHTML();
      x += '</span>';
    }
    x += this.getPrint();
    this.container.html(x);
  },

  getPrint: function() {
    return '';
  },

  //You may decide to sub this method
  onValuesUpdated: function() {
    this.print();
  },
};

function AjaxCollectionCheckboxFacet(collection, filter, container, title, options) {
  AjaxCollectionFacet.call(this, collection, filter, container, title);
  if(typeof options === typeof undefined) options = [];
  this.options = options;//If undefined, it will use ALL Tags as an option

  //Listen for checkbox changes
  container.on('change', '[data-facet-checkbox]', this.onChange.bind(this));

  this.print();
}

AjaxCollectionCheckboxFacet.prototype = Object.assign(AjaxCollectionCheckboxFacet, AjaxCollectionFacet.prototype);
AjaxCollectionCheckboxFacet.prototype = Object.assign(AjaxCollectionCheckboxFacet.prototype, {

  getPrint: function() {
    //Printing function
    var x = '<ul class="c-faceted-nav__check-group">';
    for(var i = 0; i < this.options.length; i++) {
      var option = this.options[i];
      x += '<li class="c-faceted-nav__check-item">';

      //Checkbox
      x += '<div class="o-checkbox">';

      x += '<input type="checkbox" class="c-faceted-nav__check o-checkbox__checkbox" ';
      x += 'data-index="'+i+'" ';
      x += 'data-option="'+option+'" ';
      if(this.isSelected(option)) x += 'checked ';
      x += 'data-facet-checkbox />';
      x += '<div class="o-checkbox__checkmark"></div>';
      x += '<label class="o-checkbox__label c-faceted-nav__label">'+option.escapeHTML()+'</label>';
      x += '</div>';

      x += '</li>';
    }
    x += '</ul>';
    return x;
  },

  isChecked: function(option) {
    //Is Checked for checkboxes, not in sync with the filter
    var element = this.container.find('[data-facet-checkbox][data-option="'+option+'"]');
    if(!element.prop('checked')) return false;
    return true;
  },

  isSelected: function(option) {
    //Is selected, get value from filter
    return this.filter.getSetting(option);
  },

  getCheckedOptions: function() {
    var checked = [];
    for(var i = 0; i < this.options.length; i++) {
      if(!this.isChecked(this.options[i])) continue;
      checked.push(this.options[i]);
    }
    return checked;
  },

  onChange: function(e) {
    var checkbox = $(e.target);
    var option = checkbox.attr('data-option');
    this.filter.setSetting(option, this.isChecked(option));
  },

  setOptions: function(options) {
    //Simply set the options
    this.options = options;
    this.print();
  }
});


/*** Sort ***/
/*
 *  AjaxCollection Sorting Functions
 *
 *  Objects will come into the sorter function like so:
 *    {
 *      data: { id:x, title:... },
 *      product: { data: { id:x, title:.. } }
 *    }
 */
var AjaxCollectionSort = {}

/*** NOTE These Have been made custom for cocksox web build, please adjust ***/

//Default
AjaxCollectionSort.default = {
  handle: "manual",
  name: "Featured",
  default: true,
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var handleL = AjaxCollectionSort.default.getPositionByHandle(collection, l.product.data.handle);
      var handleR = AjaxCollectionSort.default.getPositionByHandle(collection, r.product.data.handle);
      return handleL - handleR;
    });
  },
  getPositionByHandle: function(collection, handle) {
    var index = collection.products.length;
    for(var i = 0; i < collection.productHandles.length; i++) {
      if(collection.productHandles[i] != handle) continue;
      index = i;
      break;
    }
    return index;
  }
};

//By Title
AjaxCollectionSort.nameAscending = {
  handle: "title-ascending",
  name: "A-z",
  sort: function(collection, variantData) {
    return variantData.sort(function(l, r) {
      var titleL = AjaxCollectionSort.nameAscending.removeTitlePrefix(l.product.data.title);
      var titleR = AjaxCollectionSort.nameAscending.removeTitlePrefix(r.product.data.title);

      //COCKSOX Specific, extract the code an ignore it (FIRST split)

      return titleL.localeCompare(titleR);
    });
  },

  removeTitlePrefix: function(title) {
    if(title.startsWith("CX") || title.startsWith("CS")) {
      var titleArr = title.split(" ");
      var titleMerge = [];
      for(var i = 1; i < titleArr.length; i++) {
        titleMerge.push(titleArr[i]);
      }
      title = titleMerge.join(" ");
    }

    return title;
  }
};
AjaxCollectionSort.nameDescending = Object.assign(Object.assign({}, AjaxCollectionSort.nameAscending), {
  handle: "title-descending",
  name: "Z-a",
  reverse: true
});

//By Price
AjaxCollectionSort.priceAscending = {
  handle: "price-ascending",
  name: "Price, Low to High",
  sort: function(collection, variantData) {
    return variantData.sort(function(l,r) {
      return l.data.price - r.data.price;
    });
  }
};
AjaxCollectionSort.priceDescending = Object.assign(Object.assign({}, AjaxCollectionSort.priceAscending), {
  handle: "price-descending",
  name: "Price, High to Low",
  reverse: true
});


/*
 *  AjaxCollection
 *    Asyncrhonous Javascript Collection code for fetching products on the fly.
 *
 *  Dependencies:
 *    scripts/tools/query.js
 *
 *  Version:
 *    1.0.0 - 2018/08/06
 */

//CONSTANTS
var PRODUCT_CACHE_DATE_KEY = "AjaxCollectionProductCacheTime";
var PRODUCT_CACHE_DATA_KEY = "AjaxCollectionProductCacheData";

//Constructor
function AjaxCollection(container) {
  /** SETUP CONTAINERS ***/
  //You should super this class with your own collection javascript wrapper.
  this.container = container;
  this.productContainer = container.find('[data-collection-template-products]');//The place the products will get printed.
  this.handle = this.container.attr('data-collection-handle') || null;


  /*** SETUP DEFAULTS ***/
  //Attempt to detect the per-page-ness
  this.perPage = container.attr('data-collection-per-page') || 1;//Failsafe...

  //Arrays (Contains the direct list in no particular order)
  this.variants = [];
  this.products = [];
  this.filters = [];//Contains the filter components
  this.facets = [];//Contains the facet components

  //Objects, contains the list mapped by ids
  this.variantsById = {};
  this.productsById = {};
  this.pageData = {};


  /*** FETCH QUERY RELATED DATA ***/
  //Fetch Query Settings
  this.settings = this.getFilterSettingsFromUrl(window.location.search);

  //Current page, fetched from the query object
  this.initialPage = this.settings.page ? this.settings.page : 1;//Defaults to page 1.

  //Sorting?
  this.sorting = AjaxCollectionSort.default;
  if(typeof this.settings['sort_by'] === "string" ) {
    var sb = this.settings.sort_by;
    var keys = Object.keys(AjaxCollectionSort);

    for(var i = 0; i < keys.length; i++) {
      var s = AjaxCollectionSort[keys[i]];
      if(s.handle != sb) continue;
      this.sorting = s;
      break;
    }

    //Force a fake filter update
    this.onFilterUpdate();
  }


  /*** PRODUCT CACHES ***/
  //Read in data from local storage.
  var cachedData = this.readProductCache();
  this.addProducts(cachedData);
  //Note, we don't fire an update event, since this cached data may be old, and
  //subclass methods may also need more collection information (not cached), so
  //wait until it's read next before firing the event.

  //Now we're going to try and find if there's any existing product JSON on the page to use.
  this.jsonContainer = container.find('[data-collection-json]');
  if(this.jsonContainer.length) {
    //Cool, there's some JSON on the page, let's try and read it in.
    var raw = this.jsonContainer.html();
    try {
      var json = JSON.parse(raw);
      this.readProductData(json);//Attempt a read
    } catch(e) {
      console.error("Failed to read existing product JSON (Ensure it's correct)");
      console.error(e);
    }
  }

  //Product handles (for both ordering and determining what we can print)
  this.handlesJsonContainer = container.find('[data-collection-product-handles]');
  if(!this.handlesJsonContainer.length) {
    alert("Warning, the collection handles snippet was not found!");
    return;
  }
  var raw = this.handlesJsonContainer.html();
  try {
    var json = JSON.parse(raw);
    this.productHandles = json;
  } catch(e) {
    console.error("Error parsing the JSON Handles");
    console.error(e);
    return;
  }


  //Now we can fire the event if there was some cache data!
  if(cachedData && cachedData.length) this.onProductsUpdated();
}

AjaxCollection.prototype = {
  getQueryData: function(page) {
    //Returns the query parameters that will get passed to the fetch url.
    var data = {
      view: 'json',
      page: page
    };
    return data;
  },

  getQueryURL: function() {
    //Returns the url that is being queried.
    return '/collections/'+this.handle;
  },

  fetch: function(page) {
    //Double check we aren't done.
    if(!this.isRunning()) return;//Done? maybe there's an async issue, exit.

    //Page is optional, it can be a forced value, or determined by where we
    //may expect to find products we don't already have.
    if(typeof page === typeof undefined) {
      //We're going to determine the next page.

      //Initial page maybe?
      if(typeof this.pageData[""+this.initialPage] === typeof undefined) {
        return this.fetch(this.initialPage);
      }

      //Since the cache is likely to contain products from the current page, plus
      //all the products that had been fetched up to a point, it will likely be
      //already up to the page that we need... we can test there for starters.
      var expectedPage = Math.ceil((this.products.length+1) / this.perPage);
      //Have we fetched the expected page yet?
      if(typeof this.pageData[""+expectedPage] === typeof undefined) {
        //No, we haven't, let's fetch the expected page.
        return this.fetch(expectedPage);
      }

      //Ok, we have already fetched the expected page... We're going to fill in
      //the holes in our product data. Let's do this in page order since likely
      //we want the first pages to begin with.
      var fetchPage = 1;//Start with 1
      while(true) {
        if(typeof this.pageData[""+fetchPage] === typeof undefined) break;//We haven't fetched, exit!
        if(!this.pageData[""+fetchPage].length) break;//No Products on this page?
        fetchPage++;//We have fetched.. try the next page

        //Okay small note here, there is potential for an issue here, this fetchPage
        //value will forever get larger until either A, all the products are successfully fetched,
        //or B the script crashes or something...

        //I do think I need a better way of being CERTAIN that all products up
        //to this point have been fetched..
        //Quick ideas for the future:
        //  Check if there's duplicate products, if so then refetch early pages by force.
        //  Guess amount of products we should have based on page and perPage count, if getting out of hand, refetch by force.
      }
      return this.fetch(fetchPage);
    }

    if(typeof this.pageData[fetchPage] !== typeof undefined) {
      console.log("All data fetched?");
      return;
      //return this.fetch();
    }

    console.log("Fetching page " + page);

    var o = {
      url: this.getQueryURL(),
      method: 'GET',
      data: this.getQueryData(page),
      self: this,
      page: page
    };

    //Bind our custom callback.
    o.success = this.onSuccess.bind(o);
    o.error = this.onError.bind(o);
    o.request = $.ajax(o);
  },

  //For onSuccess and onError, these functions will be bound to have "this" be "this.self"..
  //Refer to fetch() for the bound object.
  onSuccess: function(data) {
    try {
      this.self.readProductData(JSON.parse(data));
    } catch(e) {
      this.error(e);//Not this.onError, again bound object callback.
    }

    if(this.self.isRunning()) this.self.fetch();
  },

  onError: function(e, i, d) {
    this.self.clearProductCache();//Integrity of cache is important

    if(e) console.log(e);
    if(i) console.log(i);
    if(d) console.log(d);
  },
  //End bound functions

  isRunning: function() {
    if(!this.hasStarted) return false;
    if(typeof this.productCount === typeof undefined) return false;//We don't know how many products there are... keep fetching.
    return this.products.length < this.productCount;
  },

  start: function() {
    //We first need to hint at our filters that we're ready, they'll have to
    //load whatever predefined settings this collection has
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      var settingSet = null;//Prevent Hoisting
      if(typeof this.settings !== typeof undefined && typeof this.settings[f.handle] !== typeof undefined) {
        settingSet = this.settings[f.handle];
      }
      f.init(settingSet);
    }
    this.onFilterUpdate();

    this.hasStarted = true;
    this.fetch();
  },

  readProductData: function(data) {
   if(typeof data.products === typeof undefined) throw new Error("Invalid JSON (Missing Products)");
   if(typeof data.collection === typeof undefined) throw new Error("Invalid JSON (Missing Collection Information)");
   if(typeof data.page === typeof undefined) throw new Error("Invalid JSON (Missing Product Data)");

   //Add products (internally)
   this.addProducts(data.products);

   //Map data to page
   this.pageData[""+data.page] = data;

   //Update collection values
   this.productCount = data.collection.all_products_count || undefined;

   //Update the cache data
   this.writeProductCache();

   //Product data has been mapped.
   this.onProductsUpdated();
  },

  addProducts: function(productArray) {
   //Adds the productArray of products to the data. No fancy updating of cache
   //or firing of events, raw adding to arrays and lists only.
   for(var i = 0; i < productArray.length; i++) {
     var p = productArray[i];
     this.addProduct(p);
   }
  },

  addProduct: function(p) {
    var id = p.data.id;

    //Don't double up. Check if this product is already in the array
    if(typeof this.productsById[id] !== typeof undefined && this.productsById[id].id === p.id) {
      //Already in the array, let's use the added version, probably newer.
      this.removeProduct(this.productsById[id]);
    }

    //Add to array, and map.
    this.products.push(p);
    this.productsById[p.data.id] = p;

    //Add child variants
    for(var x = 0; x < p.data.variants.length; x++) {
      var v = p.data.variants[x];
      this.addVariant(v);
    }
  },

  addVariant: function(v) {
    var id = v.data.id;

    //Same with products, don't double up on variants, remove the old version to
    //make way for this variant.
    if(typeof this.variantsById[id] !== typeof undefined && this.variantsById[id].id === v.id) {
      //Already in the array, let's use the added version, probably newer.
      this.removeVariant(this.variantsById[id]);
    }

    this.variants.push(v);
    this.variantsById[v.data.id] = v;
  },

  removeProduct: function(p) {
    var oldIndex = this.products.indexOf(p);
    if(oldIndex !== -1) this.products.splice(oldIndex, 1);
    for(var i = 0; i < p.data.variants.length; i++) {
      var v = p.data.variants[i];
      this.removeVariant(v);
    }
  },

  removeVariant: function(v) {
    var oldIndex = this.variants.indexOf(v);
    if(oldIndex !== -1) this.variants.splice(oldIndex, 1);
    delete this.variantsById[v.data.id];
  },

  /*
   *  Everything above this line is related to FETCHING the product information
   *  =========================================================================
   *  Everything below this line is related to PRINTING the product information
   */
  getVariantURL: function(variant) {
    var p = variant.product.data;
    var url = '/collections/'+this.handle+'/products/'+p.handle;
    if(p.variants.length) url += '?variant=' + variant.data.id;
    return url;
  },

  getVariantsToDrawForProduct: function(product) {
    //Returns an array of variants to draw for a given product.
    //Use either all variants, only one variant (related to most relevant?)
    //or specific subset of variants (say.. colour?)

    //I've provided a few common examples here, you can chose to add your own
    var mode = 'all-colors';

    //First Variant
    if(mode == 'first-variant') {
      return [product.data.variants[0]];
    }

    //All Variants
    if(mode == 'all-variants') {
      return product.data.variants;
    }

    //All Colours
    if(mode == 'all-colors') {
      //Find the option that has color... (if any)
      var colorOptionIndex = -1;
      for(var i = 0; i < product.data.options.length; i++) {
        var o = product.data.options[i].toLowerCase();
        if(o == 'color' || o == 'colour') {
          colorOptionIndex = i + 1;//Since options are 1 indexed
          break;
        }
      }
      if(colorOptionIndex === -1) {
        //OKAY so this particular product does NOT have a color option, we can
        //chose to do something custom if we like here.
        //at the moment I'm going to just display 1 of the variants
        return [ product.data.variants[0] ]
      }

      var variantsByColor = {};//The map of products, by color
      for(var i = 0; i < product.data.variants.length; i++) {
        var v = product.data.variants[i];
        var c = v.data['option'+colorOptionIndex];
        if(typeof variantsByColor[c] !== typeof undefiend && variantsByColor[c]) continue;
        //TODO: You could have a relevant secondary option check here (maybe size?)
        variantsByColor[c] = v;
      }

      var keys = Object.keys(variantsByColor);
      var variants = [];
      for(var i = 0; i < keys.length; i++) {
        variants.push(variantsByColor[keys[i]]);
      }
      return variants;
    }

    return [];//Fallback
  },

  getVariantsToDraw: function() {
    //Return an array of variants to draw. You may opt to draw each kind
    //of variant, or may opt to draw only one kind (e.g. a product thumb)
    var draw = [];

    //Get all products...
    for(var i = 0; i < this.products.length; i++) {
      var p = this.products[i];

      //Is this product in this collection?
      var inCollection = false;
      for(var x = 0; x < this.productHandles.length; x++) {
        if(p.data.handle != this.productHandles[x]) continue;
        inCollection = true;
        break;
      }
      if(!inCollection) continue;

      var variants = this.getVariantsToDrawForProduct(p);

      for(var x = 0; x < variants.length; x++) {
        var v = Object.assign({}, variants[x]);

        //Now, we can check our filters, this makes this technically an AND filter
        var filteredOut = false;
        for(var y = 0; y < this.filters.length; y++) {
          var filter = this.filters[y];
          filteredOut = !filter.filter(p.data, v.data);
          if(filteredOut) break;
        }
        if(filteredOut) continue;

        //Hack insert the product as a reference. Do this here so that we don't
        //generate a cycling error when caching the JSON for the variant!
        //(Also hence the clone)
        v.product = p;
        draw.push(v);
      }
    }

    this.unpaginatedProductCount = draw.length;//Pagination often needs this value.

    //Now we can sort.
    var sorter = this.sorting;
    if(typeof sorter !== typeof undefined && sorter) {
      draw = sorter.sort(this, draw);

      if(typeof sorter.reverse !== typeof undefined && sorter.reverse === true) {
        draw.reverse();
      }
    }

    //Paginate?
    if(typeof this.paginate === "function") {
      draw = this.paginate(draw);
    }

    return draw;
  },

  isPrinted: function(variantId) {
    //Simple check to see if a particular variant is already printed (or not)
    if(typeof variantId.data !== typeof undefined) {
      variantId = variantId.data.id;
    }

    var thumb = this.productContainer.find('[data-product-thumbnail][data-variant-id="'+variantId+'"]');
    if(!thumb.length) return null;
    return thumb;
  },

  queueDraw: function() {
    //Due to high document writes, reads, iteration etc, particularly on small devices
    //We have this nice render timeout to make sure that rendering happens when
    //needed (Every 500ms or so)
    if(typeof this.renderTimeout !== typeof undefined) return;
    this.renderTimeout = setTimeout(function() {
      this.draw();
    }.bind(this), 500);
  },

  draw: function() {
    delete this.renderTimeout;

    //Get the array of array of variants to draw.
    var draw = this.getVariantsToDraw();

    //Clear thumbs that no longer need to be printed...
    var thumbs = this.container.find('[data-product-thumbnail]');
    var thumbArray = thumbs.toArray();

    for(var i = 0; i < thumbArray.length; i++) {
      var willBePrinted = false;//If true, stay printed, else remove
      var e = $(thumbArray[i]);//Element
      for(var x = 0; x < draw.length; x++) {
        var v = draw[x];
        if(v.data.id != e.attr('data-variant-id')) continue;
        willBePrinted = true;//Stay printed.
        break;
      }
      if(willBePrinted) continue;
      //Remove
      e.remove();
    }

    //Now we should only have the variants that are printed left
    var previous = null;//Used to track the "previously printed element"
    for(var i = 0; i < draw.length; i++) {
      var variant = draw[i];
      var element = this.isPrinted(variant);

      if(!element) {
        //Product is not printed... generate the HTML
        element = this.generatePrint(variant);
        if(previous) {
          previous = $(element).insertAfter(previous);
          continue;
        } else {
          //Is there any existing element?
          previous = this.productContainer.children().first();
          if(previous.length) {
            previous = $(element).insertBefore(previous);
            continue;
          }

          //Inject HTML and get element.
          this.productContainer.html(element);
          previous = $(this.productContainer.children().first());
          continue;
        }
      }

      //This is the first element, we have nothing to do!
      if(!previous) {
        previous = element;
        continue;
      }

      //Insert after previous element.
      element.insertAfter(previous);
      previous = element;
    }

    this.drawnProducts = draw;
    this.onProductsDrawn(draw);
  },

  //Expected to be overriden
  paginate: function(e) { return e; },

  //Events
  onProductsUpdated: function() { /* Called when product data has been added to the list */ },
  onProductsDrawn: function() { /* Called when products have been drawn */ },

  generatePrint: function(variant) {
    //Super simple, override this with your print.
    var x = '<div ';
    x += 'data-product-thumbnail ';
    x += 'data-product-handle="'+variant.product.data.handle+'" '
    x += 'data-product-id="'+variant.product.data.id+'" '
    x += 'data-variant-id="'+variant.data.id+'" '
    x += '>' + variant.data.title + '</div>';
    return x;
  },


  /*
   *  Everything above this line is related to PRINTING the product information
   *  =========================================================================
   *  Everything below this line is related to CACHING the product information
   */
  readProductCache: function() {
    if(typeof localStorage === typeof undefined) return [];
    if(typeof localStorage.getItem === typeof undefined) return [];
    if(!localStorage.getItem(PRODUCT_CACHE_DATA_KEY)) return [];
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) return [];

    //First, how old is this data?
    if(!this.isCacheAlive()) return [];//Out of date.

    //Now, let's attempt a read
    try {
      var dataRaw = localStorage.getItem(PRODUCT_CACHE_DATA_KEY);
      var data = JSON.parse(dataRaw);

      if(!Array.isArray(data)) throw new Error("Invalid Product Data (Not an array)");

      //Good?
      return data;
    } catch(e) {
      console.error("Failed to read Product Data from cache.");
      console.error(e);
    }
    return [];//:(
  },

  isCacheAlive: function() {
    //Returns TRUE if the cache is still allowed to be use, false if it has
    //expired.
    if(typeof localStorage === typeof undefined) return false;
    if(typeof localStorage.getItem === typeof undefined) return false;
    if(!localStorage.getItem(PRODUCT_CACHE_DATA_KEY)) return false;
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) return false;

    //First, how old is this data?
    try {
      var cacheAge = new Date( JSON.parse(localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) );
      var now = new Date();
      var diff = now - cacheAge;
      //Cache cannot be in the future
      if(diff < 0 || isNaN(diff) || !isFinite(diff)) throw new Error("Cache from the future?");
      if(diff > 1000*60*10) return false;//Cache expired (1000ms * 60s * 10mins)
      //Cache is good to use
    } catch(e) {
      console.error("Failed to read Product Data age.");
      console.error(e);
      return false;
    }
    return true;
  },

  writeProductCache: function() {
    if(typeof localStorage === typeof undefined) return;//Nothing to do?
    if(typeof localStorage.getItem === typeof undefined) return;
    if(typeof localStorage.setItem === typeof undefined) return;
    if(typeof this.canWriteProductCache !== typeof undefined && !this.canWriteProductCache) return;

    //Only update the time if it's non existant, or expired
    if(!localStorage.getItem(PRODUCT_CACHE_DATE_KEY)) {
      localStorage.setItem(PRODUCT_CACHE_DATE_KEY, JSON.stringify(new Date().getTime()) );//Set Cache Time
    } else if(!this.isCacheAlive()) {
      this.canWriteProductCache = false;//No Writing allowed
      //Clear the existing cache data
      this.clearProductCache();
      return;
    }

    //Now we have our product data to be cached, let's attempt to store it
    try {
      localStorage.setItem(PRODUCT_CACHE_DATA_KEY, JSON.stringify(this.products));
    } catch(e) {
      console.error("Failed to update Product Data cache");
      console.error(e);
    }
  },

  clearProductCache: function() {
    try {
      localStorage.removeItem(PRODUCT_CACHE_DATE_KEY);
      localStorage.removeItem(PRODUCT_CACHE_DATA_KEY);
    } catch(e) {
      console.error("Failed to clear existing Product Data Cache");
      console.error(e);
    }
  },

  /*
   *  Everything above this line is related to CACHING the product information
   *  =========================================================================
   *  Everything below this line is related to FILTERING the product information
   */
  //Please note that actual filtering is part of the getVariantsToDrawForProduct function.
  addFilter: function(filter) {
    this.filters.push(filter);

    this.onFilterUpdate();
  },

  removeFilter: function(filter) {
    var index = this.filters.indexOf(filter);
    if(index === -1) return;
    this.filters.splice(index, 1);
    this.onFilterUpdate();
  },


  /*
    Here's my "Really quick" How the URLs work for both parsing and unparsing
    Example Query:
      ?size=20,30,50&color=Red&group=(range%253D0-100%2526vendor%253DApple)

    Bloated:
      {
        size: [ 20, 30, 50 ],
        color: [ "Red" ],
        group: {
          range: {min:0, max:100},
          vendor: "Apple"
        }
      }

    Just an example.
  */

  getFilteredUrl: function() {
    //Returns the url for the page, based on current filter settings.
    var x = '/collections/' + this.handle;


    //Fallback Tag support, tag only the first tag from each filter and put them
    //into a nice + array, not exactly the same but very similar
    var tags = [];
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      if(!(f instanceof AjaxCollectionTagFilter)) continue;
      if(!f.tags.length) continue;

      //Check the operation type, if it's AND we may be able to do it the old
      //fashioned way.
      if(f.operation == "AND") {
        //Awesome, this is an AND Filter, we can be more specific
        tags.concat(f.tags);
      } else {
        tags.push(f.tags[0]);//Only going to use the first tag.
      }
    }
    var oldTags = tags;
    var tags = [];
    for(var i = 0; i < oldTags.length; i++) {
      var t = oldTags[i];
      if(tags.indexOf(t) !== -1) continue;
      tags.push(t);
    }
    if(tags.length) x += '/' + tags.join('+').toLowerCase();//Shopify convers the tags to lowercase


    //Query time
    var queryParams = this.getFilterSettings();
    if(this.page > 1) queryParams['page'] = this.page;

    if(typeof this.sorting !== typeof undefined && (
      typeof this.sorting.default === typeof undefined ||
      this.sorting.default === false
    )) {
      queryParams['sort_by'] = this.sorting.handle;
    }

    var queryKeys = Object.keys(queryParams);
    if(queryKeys.length) {
      //Create our escaping function...
      var escape = function(object) {
        var keys = Object.keys(object);
        var bufferArray = [];

        for(var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var value = object[key];
          var buffer;

          //Change the format depending on the type
          if(Array.isArray(value)) {
            if(!value.length) continue;
            buffer = value.join(',');//Comma seperate Arrays

          } else if(typeof value === "object") {
            var subBuffer = escape(value);//Objects become wrapped subobjects
            if(!subBuffer.length) continue;
            buffer = "(" + subBuffer + ")";

          } else {
            buffer = "" + value;//Convert to string
            if(!buffer.length) continue;//Empty string.
          }

          //Append to array!
          bufferArray.push(encodeURIComponent(key) + '=' + encodeURIComponent(buffer));
        }

        //Join with ampersands (They'll be escaped if sub objecting)
        return bufferArray.join('&');
      };

      x += '?'+escape(queryParams);//Add our query escape
    }

    return x;
  },

  getFilterSettings: function() {
    var o = {};
    for(var i = 0; i < this.filters.length; i++) {
      var f = this.filters[i];
      var settings = f.getSettings();

      //First see if there's anything worth storing... we don't want to store
      //default values
      if(Array.isArray(settings) && !settings.length) continue;//Nothing to store...

      o[f.handle] = settings;
    }
    return o;
  },

  getFilterSettingsFromUrl: function(url) {
    //Reverse of the above two functions.
    var params = url.split('?');//Extract the query string...
    if(params.length == 0) {
      return {};//None was passed? / Empty string
    } else if(params.length == 1) {
      //No URL, just a query string, don't need to do anything
    } else {
      var newParams = [];//Multiple Query strings, join them together and drop the URL
      for(var i = 1; i < params.length; i++) {
        newParams.push(params[i]);
      }
      params = newParams;
    }
    params = params.join('?');

    //Now we have the params string, let's create our unescaping function
    var unescape = function(string) {
      var o = {};//We're going to dump our data into this object
      var parts = string.split('&');
      //Now we have an array like ["page=2", "size=20,30,40", "group=(escaped..)"]
      for(var i = 0; i < parts.length; i++) {
        //Figure out the type!
        var spl = parts[i].split('=');//Should now be [key, value]
        if(spl.length != 2) continue;//?
        var key = spl[0];
        var val = decodeURIComponent(spl[1]);

        //Switch types
        if(val.startsWith("(")) {
          //Likely a nested object
          var val = val.substring(1, val.length-1);//Remove the brackets
          val = unescape(decodeURIComponent(val));//Unescape.
        } else {
          //Default (array)
          val = val.split(",");//Seperates into either ["10","20","30"] or ["String"]
          if(!val.length) continue;//Ignore empty
          if(val.length == 1) val = val[0];//If it's an array of 1, change into a single object
        }
        o[key] = val;//Map
      }

      return o;//Return parsed object
    };

    var settings = unescape(params);
    return settings;
  },

  onFilterUpdate: function() {
    //Called by my children filters whenever they update at all, forces a redraw
    //and in turn will filter the products.

    //First, update the history state.
    var url = this.getFilteredUrl();
    history.replaceState(this.getFilterSettings(), "", this.getFilteredUrl());

    //Next, queue a draw (essentially forces the products to filter)
    this.queueDraw();

    //Update our facets
    for(var i = 0; i < this.facets.length; i++) {
      var facet = this.facets[i];
      facet.onValuesUpdated();
    }

    //Finally, trigger the event for subclasses
    this.onProductsFiltered();
  },

  //Filter events
  onProductsFiltered: function() {/* Called when the products are filtered. */ },


  /*
   *  Everything above this line is related to FILTERING the product information
   *  =========================================================================
   *  Everything below this line is related to FACETING the product information
   */
  addFacet: function(facet) {
    this.facets.push(facet);
  },

  removeFacet: function(facet) {
    var index = this.facets.indexOf(facet);
    if(index === -1) return;
    this.facets.splice(index, 1);
  },

  /*
   *  Everything above this line is related to FACETING the product information
   *  =========================================================================
   *  Everything below this line is related to SORTING the product information
   */
  attachSorter: function(e) {
    this.sorters = this.sorters || [];
    this.sorters.push(e);
    e.on('change', this.onSort.bind(this));
    e.html(this.getSorterCode());
  },

  setSort: function(sort) {
    this.sorting = sort;
    this.updateSorters();
    this.onFilterUpdate();
  },

  onSort: function(e) {
    var self = $(e.currentTarget);
    var val = self.val();
    var sort = AjaxCollectionSort[val];
    if(typeof sort === typeof undefined) return;
    this.setSort(sort);
  },

  updateSorters: function() {
    this.sorters = this.sorters || [];
    var code = this.getSorterCode();
    for(var i = 0; i < this.sorters.length; i++) {
      this.sorters[i].html(code);
    }
  },

  getSorterCode: function() {
    var keys = Object.keys(AjaxCollectionSort);
    var x = '';
    for(var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var v = AjaxCollectionSort[k];
      if(typeof v.hide !== typeof undefined && v.hide === true) continue;
      var isSelected = this.sorting.handle === v.handle;
      x += '<option value="'+k+'" '+(isSelected?'selected':'')+'>';
      x += (v.name||k).escapeHTML();
      x += '</option>';
    };
    return x;
  }
};

/*
 *  Carousel
 *    Scripts for carousel
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/carousel.liquid - Required for building carousel component.
 *
 *  Version:
 *    1.0.0 - 2018/01/25
 */
function Carousel(container) {
  this.container = container;
  this.id = container.data('section-id');
  window.carousels[this.id] = this;  

  //Now read attributes
  let options = {
    infinite: this.container.data('infinite') === true ? true : false,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: this.container.data('dots') == true,
    arrows: this.container.data('arrows') == true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    adaptiveHeight: true
  };
  this.slick = this.container.slick(options);
}

Carousel.prototype = {
  remove: function() {
    this.container.remove();
    delete window.carousels[this.id];
    delete window.carouselForceSlide[this.id];
  },

  getSlideElementFromBlock: function(block) {
    let element = this.container.find('[data-slide][data-block-id="'+block+'"]');
    return element;
  },

  getSlideIndexFromBlock: function(block) {
    let element = this.getSlideElementFromBlock(block);
    console.log(element);
    return parseInt(element.data('index'));
  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

//Globals
window.carousels = window.carousels || {};
window.carouselForceSlide = window.carouselForceSlide || {};

//Events/Setup
$(document).ready(function() {
  $('[data-carousel]').each(function() {
    var self = $(this);
    if( window.carousels[self.data('section-id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new Carousel(self);
  });
});

//Section events
$(document).on('shopify:section:load', '.c-section__carousel', function(e) {
  let id = e.detail.sectionId;
  var carousel = window.carousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new Carousel( $('[data-carousel][data-section-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-section__carousel', function(e) {
  let id = e.detail.sectionId;
  var carousel = window.carousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
  window.carouselForceSlide[id] = 0;
});

$(document).on('shopify:section:select', '.c-section__carousel', function(e) {
  let id = e.detail.sectionId;
  var carousel = window.carousels[id];
  if(typeof carousel === typeof undefined) return;
  if(!window.carouselForceSlide[id]) return;
  carousel.setSlide( window.carouselForceSlide[id] );
});

$(document).on('shopify:block:select', '.c-section__carousel', function(e) {
  let section = e.detail.sectionId;
  let block = e.detail.blockId;
  var carousel = window.carousels[section];
  if(typeof carousel === typeof undefined) return;
  let index = carousel.getSlideIndexFromBlock(block);
  window.carouselForceSlide[section] = index;
  carousel.setSlide(index);
});
/*
 *  Blog Feature
 *    Blog Feature Scripts
 *
 *  Dependencies:
 *    slick
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/19
 */
//data-blog-feature-carousel

$(document).ready(function() {
  $('[data-blog-feature-carousel]').each(function(e, i) {
    var self = $(this);
    self.slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1
          }
        },
      ]
    });
  });
});

/*
 *  Collection Carousel
 *    Scripts and logic for the collection carousel.
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *    sections/collection-carousel.liquid - Required for building the collection carousel.
 *
 *  Version:
 *    1.0.0 - 2018/01/31
 */
function CollectionCarousel(container) {
  this.container = container;
  this.id = container.data('id');

  let options = {
    infinite: this.container.data('infinite') == false ? false : true,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: this.container.data('dots') == true,
    arrows: this.container.data('arrows') == true,
    adapativeHeight: true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 500,
        settings: "unslick"
      }
    ]
  };
  this.slick = this.container.slick(options);

  window.collectionCarousels[this.id] = this;
}

CollectionCarousel.prototype = {
  remove: function() {
    this.container.remove();

  },

  setSlide: function(slide) {
    this.container.slick('slickGoTo', slide);
  }
};

window.collectionCarousels = window.collectionCarousels || {};

$(document).ready(function() {
  $('[data-collection-carousel]').each(function() {
    var self = $(this);
    if(window.collectionCarousels[self.data('id')] ) return;//Don't double up carousels
    if(self.hasClass('slick-initialized')) return;
    new CollectionCarousel(self);
  })
});

//Section events
$(document).on('shopify:section:load', '.c-section__collection-carousel', function(e) {
  let id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel !== typeof undefined) {
    carousel.remove();
  }
  carousel = new CollectionCarousel( $('[data-collection-carousel][data-id="'+id+'"]') );
});

$(document).on('shopify:section:unload', '.c-section__collection-carousel', function(e) {
  let id = e.detail.sectionId;
  var carousel = window.collectionCarousels[id];
  if(typeof carousel === typeof undefined) return;
  carousel.remove();
});

/*
 *  Featured Video
 *    Contains the script(s) needed to play the main video
 *
 *  Version:
 *    1.0.0 - 2018/07/19
 */
$(document).on('click', '[data-featured-video-play]', function(e) {
  var self = $(this);
  var featuredVideo = self.closest('[data-featured-video]');
  if(!featuredVideo.length) return;
  e.preventDefault();
  e.stopPropagation();
  featuredVideo.addClass('is-visible');
});

/*
 *  Icon Grid
 *    Icon Grid Section
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/26
 */
function IconGrid(container) {
  this.container = container;

  this.container.on('click', '[data-icon-grid-icon][data-icon-grid-has-box]', this.onToggleBox.bind(this));
}

IconGrid.prototype = {
  onToggleBox: function(e) {
    e.preventDefault();
    e.stopPropagation();

    var self = $(e.currentTarget);
    var id = self.attr('data-block-id');
    var box = this.container.find('[data-icon-grid-box][data-block-id="'+id+'"]');

    var wasOpen = false;

    //Find the box that this clicked element belongs to.
    if(box.hasClass('is-open')) wasOpen = true;

    this.container.find('[data-icon-grid-icon]').removeClass('is-open');
    this.container.find('[data-icon-grid-box]').removeClass('is-open');

    if(wasOpen) return;

    self.addClass('is-open');
    box.addClass('is-open');
  }
};

$(document).ready(function() {
  $('[data-icon-grid]').each(function(e, i) {
    var self = $(this);
    var iconGrid = new IconGrid(self);
  });
});

/*
 *  Instagram
 *    Scripts for Instagram feeds
 *
 *  Dependencies:
 *    jQuery - Required for selectors
 *    Instafeed.JS - Used to manage the instagram integration
 *    sections/instagram.liquid
 *
 *  Version:
 *    1.0.0 - 2018/02/05
 */

var DEFAULT_INSTAGRAM_TEMPLATE = '<div class="c-instagram__photo-container"><a href="{{link}}" target="_blank" class="c-instagram__photo">';
DEFAULT_INSTAGRAM_TEMPLATE += '<img src="{{image}}" />';
DEFAULT_INSTAGRAM_TEMPLATE += '</a></div>';

var DEFAULT_INSTAGRAM_OPTIONS = {
  get: 'user',
  template: DEFAULT_INSTAGRAM_TEMPLATE,
  resolution: 'low_resolution'
}

function instagram(self) {
  if(self.hasClass('is-running')) return;
  var token = self.data('token');
  if(!token || !token.length) return;
  var spl = token.split('.');
  if(!spl.length) return;

  //Need a polyfill for Object.assign
  var newOptions = JSON.parse(JSON.stringify(DEFAULT_INSTAGRAM_OPTIONS));
  newOptions.userId = spl[0];
  newOptions.accessToken = token;
  newOptions.target = self.attr('id');
  newOptions.limit = self.data('limit') || 6;

  var feed = new Instafeed(newOptions);
  feed.run();
}

$(document).ready(function() {
  $('[data-instagram-feed]').each(function() {
    instagram($(this))
  })
});

//Section events
$(document).on('shopify:section:load', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  instagram(feed)
});

$(document).on('shopify:section:unload', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
  var feed = $('[data-instagram-feed][data-feed-id="'+id+'"]');
  if(!feed.hasClass('is-running')) return;
  feed.remove();
});

$(document).on('shopify:section:select', '.c-section__instagram', function(e) {
  var id = e.detail.sectionId;
});

/*
 *  Mobile Menu
 *    Contains the scripts for the mobile menu, including accordion design
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/10
 */

//Global Menu Toggle Click Listener
$(document).on('click', '[data-mobile-menu-toggle]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var menu = $('[data-mobile-menu]');
  var buttons = $('[data-mobile-menu-toggle]');
  var isMenuOpen = menu.hasClass('is-open');
  var container = $('[data-mobile-menu-button]');

  if(isMenuOpen) {
    menu.removeClass('is-open');
    buttons.removeClass('is-menu-open');
    container.removeClass('is-menu-open');
  } else {
    menu.addClass('is-open');
    buttons.addClass('is-menu-open');
    container.addClass('is-menu-open');
  }
});

$(document).on('click', '[data-mobile-menu-link]', function(e) {
  var self = $(this);
  self.toggleClass('is-open');
  var submenu = self.parent().find('[data-mobile-menu-submenu]');
  if(!submenu.length) return;

  e.preventDefault();
  e.stopPropagation();
  submenu.toggleClass('is-open');
});


$(document).on('click', '[data-mobile-menu-submenu-link]', function(e) {
  var self = $(this);
  self.toggleClass('is-open');
  var subsubmenu = self.parent().find('[data-mobile-menu-subsubmenu]');
  if(!subsubmenu.length) return;

  e.preventDefault();
  e.stopPropagation();
  subsubmenu.toggleClass('is-open');
});

/*
 *  Product Carousel
 *    Product Carousel Scripts
 *
 *  Dependencies:
 *    slick - Slick is required to run the carousel itself
 *    jQuery - jQuery is required for event listeners
 *
 *  Version:
 *    1.0.0 - 2018/02/16
 */
function ProductCarousel(container) {
  this.container = container;
  this.id = this.container.attr('data-id') || Math.floor(Math.random()*10000);

  this.carousel = this.container.find('[data-product-carousel-carousel]');
  //this.navigation = this.container.find('[data-product-carousel-navigation]');

  //Add ID classes
  this.carousel.addClass('c-product-carousel__carousel--'+this.id);
  //this.navigation.addClass('c-product-carousel__navigation--'+this.id);

  //Nav Options
  //this.navOptions = this.container.find('[data-product-carousel-nav]');

  //Carousel Slick
  var options = {
    infinite: true,
    slidesToShow: this.container.data('slides-to-show') || 1,
    slidesToScroll: this.container.data('slides-to-scroll') || 1,
    autoplay: this.container.data('autoplay') == true,
    dots: this.container.data('dots') == true,
    arrows: this.container.data('arrows') == true,
    autoplaySpeed: this.container.data('autoplay-speed') || 5000,
    cssEase: this.container.css('animation-timing-function') || 'cubic-bezier(0.23, 1, 0.32, 1)',
    adaptiveHeight: this.container.data('adaptiveHeight') == false ? false : true,
    draggable:true,
    centerMode: true,
    //swipe:false
  };


/*
  //Navigation Slick
  this.navigationSlick = this.navigation.slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    asNavFor: '.c-product-carousel__carousel--'+this.id,
    centerMode: false,
    vertical:true,
    draggable:true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 4,
          vertical:false,
        }
      }
    ]
  });
*/
  //options.asNavFor = '.c-product-carousel__navigation--'+this.id;

  this.slick = this.carousel.slick(options);
  this.adjustSlideColors();

  this.carousel.on('afterChange', this.adjustSlideColors.bind(this));
  this.carousel.on('beforeChange', this.adjustSlideColors.bind(this));

  window.productCarouselsArr.push(this);
  window.productCarousels[this.id] = this;

  this.container.attr("data-initialized", true);
}

ProductCarousel.prototype = {
  remove: function() {
    var index = window.productCarouselsArr.indexOf(this);
    window.productCarouselsArr.splice(index, 1);
    this.container.remove();
  },

  getCurrentSlide: function() {
    return this.carousel.slick('slickCurrentSlide');
  },

  adjustSlideColors: function() {
    //this.navOptions.removeClass('slick-current');
    //this.navOptions
    //  .filter('[data-product-carousel-index="'+this.getCurrentSlide()+'"]')
    //  .addClass('slick-current')
    ;
  },

  goToSlide: function(slide) {
    this.adjustSlideColors();
    this.carousel.slick('slickGoTo', slide);
  }
}

window.productCarouselsArr = window.productCarouselsArr || [];
window.productCarousels = window.productCarousels || {};

$(document).ready(function() {
  $('[data-product-carousel]').each(function() {
    var self = $(this);
    if(self.attr('data-initialized')) return;
    var carousel = new ProductCarousel(self);
  })
})

/*
 *  Product Lifestyle Carousel
 *    Carousel for Product Lifestyle Shots
 *
 *  Dependencies:
 *    jQuery
 *    slick
 *
 *  Version:
 *    1.0.0 - 2018/07/26
 */
function ProductLifestyleCarousel(container) {
  this.container = container;

  this.slick = this.container.slick({
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true
  });

  this.container.on('click', '[data-product-lifestyle-slide]', this.onLifestyleSlideClick.bind(this));
  this.container.on('beforeChange', this.onSlideChange.bind(this));
}

ProductLifestyleCarousel.prototype = {
  onLifestyleSlideClick: function(e) {
    var self = $(e.currentTarget);
    var index = self.attr('data-slick-index');
    var currentTarget = this.container.find('[data-product-lifestyle-slide][data-slick-index="'+index+'"]');
    if(currentTarget.hasClass('slick-center')) {
      //Lightbox can go here
      return;
    }
    this.container.slick('slickGoTo', index);
  },

  onSlideChange: function(e, a, i, o) {
    this.container.find('[data-product-lifestyle-slide]').removeClass('is-current');
    var target = this.container.find('[data-product-lifestyle-slide][data-index="'+o+'"]');
    target.addClass('is-current');
  }
};

$(document).ready(function(e) {
  $('[data-product-lifestyle-carousel]').each(function(e, i) {
    var self = $(this);
    var carousel = new ProductLifestyleCarousel(self);
  });
});

//TODO: Add in options for the theme customizer

/*
 *  Product Review Testimonials
 *    Product Review Testimonials Section
 *
 *  Dependencies:
 *    jQuery
 *
 *  Version:
 *    1.0.0 - 2018/07/25
 */
function ProductReviewTestimonials(container) {
  this.container = container;
  this.formContainer = container.find('[data-review-testimonials-form]');
  this.testimonailsContainer = container.find('[data-review-testimonials-testimonails]');

  this.container.on('click', '[data-review-testimonials-toggle-reviews]', this.toggleReviews.bind(this));
  this.container.on('click', '[data-review-testimonials-toggle-form]', this.toggleForm.bind(this));
  this.container.on('click', '.spr-summary-actions-newreview', this.toggleForm.bind(this));

  this.formLooker = setInterval(this.lookForForm.bind(this), 100);
}

ProductReviewTestimonials.prototype = {
  lookForForm: function() {
    this.form = this.container.find('.spr-form');
    if(!this.form.length) return;
    clearInterval(this.formLooker);
    this.form.appendTo(this.formContainer);
  },

  toggleReviews: function(e) {
    e.preventDefault();
    e.stopPropagation();

    if(this.container.hasClass('is-reviews-visible')) {
      this.container.removeClass('is-reviews-visible');
    } else {
      this.container.removeClass('is-form-visible');
      this.container.addClass('is-reviews-visible');
    }
  },

  toggleForm: function(e) {
    e.preventDefault();
    e.stopPropagation();

    if(this.container.hasClass('is-form-visible')) {
      this.container.removeClass('is-form-visible');
    } else {
      this.container.removeClass('is-reviews-visible');
      this.container.addClass('is-form-visible');
    }
  }
};

//Ready
$(document).ready(function() {
  $('[data-product-review-testimonials]').each(function() {
    var self = $(this);
    var testimonials = new ProductReviewTestimonials(self);
  });
});

/*
 *  Addresses Page
 *    Scripts for Addresses Page
 *
 *  Dependencies:
 *    jQuery - jQuery is required for event listeners
 *    scripts/tools/language.js - Required for messasges.
 *  
 *
 *  Version:
 *    1.0.0 - 2018/02/21
 */
//window.Language.required('customer.addresses.delete_confirm');

//Address Create
$(document).on('click', '[data-address-create-toggle]', function(e) {
  e.preventDefault();
  var self = $(this);
  $('[data-address-create-form]').toggleClass('is-visible');
});

$(document).on('click', '[data-address-create-show]', function(e) {
  e.preventDefault();

  var self = $(this);
  $('[data-address-create-form]').addClass('is-visible');
});

$(document).on('click', '[data-address-create-hide]', function(e) {
  e.preventDefault();

  var self = $(this);
  $('[data-address-create-form]').removeClass('is-visible');
});

//Address Edit
$(document).on('click', '[data-address-edit-toggle]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.toggleClass('is-visible');
});

$(document).on('click', '[data-address-edit-show]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.addClass('is-visible');
});

$(document).on('click', '[data-address-edit-hide]', function(e) {
  e.preventDefault();

  var self = $(this);
  if(typeof self.data('index') === typeof undefined) {
    var target = self.closest('[data-address-edit-form]');
  } else {
    var target = $('[data-address-edit-form][data-index="'+self.data('index')+'"]');
  }
  target.removeClass('is-visible');
});

//Address Delete
$(document).on('click', '[data-address-delete]', function(e) {
  var self = $(this);
  var id = self.data('id');
  if(!id) return;
  if (confirm('Confirm deletion?')) {
    Shopify.postLink('/account/addresses/' + id, {parameters: {_method: 'delete'}});
  }
});
/*
 *  Cart Template
 *    Scripts for the cart page template.
 *
 *  Dependencies:
 *    jQuery
 *    scripts/tools/cart.js
 *    scripts/tools/currency.js
 *    scripts/objects/_cart-quantity-selector.js
 *    scripts/objects/_quantity-selector.js
 *    templates/cart.page-ajax.liquid
 *
 *  Version:
 *    1.0.0 - 2018/08/01
 */
function CartTemplate(container) {
  this.container = container;
  this.form = container.find('[data-cart-page-form]');
  this.loader = container.find('[data-cart-page-loader]');
  this.body = container.find('[data-cart-page-body]');

  $(document).on('onCartPending', this.onCartPending.bind(this));
  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));
  this.container.on('submit', '[data-cart-page-form]', this.onSubmit.bind(this));
  this.container.on('click', '[data-cart-page-remove-item]', this.onRemove);
}

CartTemplate.prototype = {
  onCartPending: function() {
    this.container.addClass('is-loading');
  },

  onCartUpdate: function(e, data) {
    console.log("Cart Data:");
    console.log(data);
    if(data.items.length < 1) {
      return window.location.reload();
    }
    this.fetchAndPrint();
  },

  onRemove: function(e) {
    e.preventDefault();
    e.stopPropagation();
    var self = $(this);
    var index = self.attr('data-line-index');
    window.Cart.remove(index);
  },

  fetchAndPrint: function() {
    var o = {
      url: '/cart',
      data: {
        view: 'page-ajax'
      }
    };
    o.self = this;
    o.success = this.onPrintData.bind(o);
    o.error = this.onPrintError.bind(o);
    var request = $.ajax(o);
    o.request = request;

    this.lastRequest = request;
  },

  onPrintData: function(data) {
    //Take the raw cart data and print the correct information onto the ajax cart
    this.self.container.removeClass('is-loading');
    if(typeof data === typeof undefined || !data.length) {
      //TODO: Add an error handler
      return this.self.onPrintError.bind(this)(data);
    }

    this.self.body.html(data);
    this.self.container.find('[data-cart-quantity-selector]').each(function(e, i) {
      var selector = new CartQuantitySelector($(i));
    });
    this.self.body.trigger('onMoneyChange');
  },

  onPrintError: function(e, i, a, b) {
    console.log(e);
    console.log(i);
    console.log(a);
    console.log(b);
    this.self.list.html('<p>error</p>');
  },

  onSubmit: function() {
  }
};

$(document).ready(function() {
  $('[data-cart-page]').each(function() {
    var self = $(this);
    window.cartTemplate = new CartTemplate(self);
  });
});

/*
 *  Collection Template
 *
 *
 *  Dependencies:
 *    scripts/components/AjaxCollection.js
 *
 *  Version:
 *    1.0.0 - 2018/07/20
 */
function CollectionTemplate(container) {
  AjaxCollection.call(this, container);

  window.Language.required("collections.general.no_matches");

  /** Values **/
  this.viewMoreProducts = this.perPage;//For pagination.

  /** Components **/
  this.viewMoreButton = container.find('[data-collection-template-load-more]');

  /** Event Handlers **/
  container.on('click', '[data-collection-template-load-more]', this.viewMore.bind(this));
  container.on('click', '[data-collection-template-toggle-filters]', this.toggleFilters.bind(this));

  /** Filters **/
  var styleFilter = new AjaxCollectionTagFilter("style", this, "OR");
  var pouchFilter = new AjaxCollectionTagFilter("pouch", this, "OR");
  var sizeFilter;
  var fabricFilter;

  //Add our filters, we could use a group, but the default functionality for the
  //filters is AND based, so that's what we want in this case.
  this.addFilter(styleFilter);
  this.addFilter(pouchFilter);

  /** Facets **/

  /** Sorters **/
  this.attachSorter(container.find('[data-collection-sort-by]'));

  /** Begin **/
  this.start();//Start fetching products in the background;.
  this.draw();//FORCE A redraw, great for SEO.
}

CollectionTemplate.prototype = Object.assign(Object.assign({}, AjaxCollection.prototype), {
  paginate: function(e) {
    //This is the "Load More" functionality, where pressing the load more button
    //Will increase the amount of products we print.
    let a = [];
    for(let i = 0; i < Math.min(this.viewMoreProducts, e.length); i++) {
      a.push(e[i]);
    }
    return a;
  },

  viewMore: function(e) {
    e.preventDefault();
    e.stopPropagation();
    this.viewMoreProducts += this.perPage;
    this.draw();
  },

  onProductsDrawn: function(drawn) {
    if(this.viewMoreProducts < this.unpaginatedProductCount) {
      this.viewMoreButton.removeClass('is-hidden');
    } else {
      this.viewMoreButton.addClass('is-hidden');
    }

    if(!drawn || !drawn.length) {
      var x = '<h3 class="c-collection-template__sold-out-title">';
      x += Language.get("collections.general.no_matches").escapeHTML();
      x += '</h3>';
      this.container.html(x);
    }
  },

  toggleFilters: function(e) {
    e.stopPropagation();
    e.preventDefault();
    this.container.toggleClass('is-open');
  },

  onProductsFiltered: function() {
    this.viewMoreProducts = this.perPage;
  },

  generatePrint: function(variant) {
    var v = variant.data;
    var p = variant.product.data;

    var x = '';
    x += '<div ';
    x += 'class="o-product-thumbnail__container ';
    x += 'o-product-thumbnail__container--style-color" ';
    x += 'data-product-thumbnail data-product-handle="'+p.handle+'" ';
    x += 'itemprop="itemListElement" itemscope itemtype="http://schema.org/Product"'
    x += '>';

    //Label
    x += '<div class="o-product_thumbnail__label">';
    x += 'Perfect for your home';
    x += '</div>';

    //Wrapper
    x += '<a href="' + this.getVariantURL(variant) + '" ';
    x += 'class="o-product-thumbnail o-product-thumbnail--style-color" >';

    //Meta Info
    x += '<meta itemprop="name" content="';
    x += p.title.escapeHTML() + (p.variants.length != 1 ? ' - ' + v.title.escapeHTML() : '');
    x += '" />';
    x += '<meta itemprop="url" content="'+window.location.origin+v.url+'" />';
    x += '<meta itemprop="brand" content="'+p.vendor.escapeHTML()+'" />';

    //Image and Sizer
    x += '<span class="u-box-sizer--moz-fix o-product-thumbnail__image-container--style-color">';
    x += ImageTools.generatePicture(
      v.featured_image ? v.featured_image.src : p.featured_image,
      500,
      [150,250,500],
      'o-product-thumbnail__image o-product-thumbnail__image--style-color',
      v.featured_image ? ( v.featured_image.alt || v.title ).escapeHTML() : v.title.escapeHTML()
    );
    x += '</span>';

    //Title, Price
    x += '<span class="o-product-thumbnail__footer--style-color">';
    x += '<h3 class="o-product-thumbnail__title--style-color">';
    x += p.title.escapeHTML();
    x += '</h3>';
    x += '<span class="o-product-thumbnail__money--style-color" data-currency data-money="'+v.price+'">';
    x += Currency.formatMoney(v.price);
    x += '</span>';

    x += '</span>';

    x += '<a class="o-btn o-btn--add-to-cart" href="'+this.getVariantURL(variant)+'">';
    x += 'Shop now';
    x += '</a>';

    x += '</div>';
    return x;
  }
});

//Register
window.collectionTemplates = window.collectionTemplates || [];

$(document).ready(function() {
  $('[data-collection-template]').each(function(e, i) {
    var self = $(this);
    var template = new CollectionTemplate(self);
    window.collectionTemplates.push(template);
    window.test = template;
  });
});

/*
 *  Product Template
 *    Contains logic for the product template.
 *
 *  Dependencies:
 *    scripts/objects/_variant-selector.js
 *    scripts/objects/cart.js
 *
 *  Version:
 *    1.0.0 - 2018/07/30
 */
function ProductTemplate(container) {
  this.container = container;

  this.variantSelector = this.container.find('[name="id"]');
  this.qtySelector = this.container.find('[name="quantity"]');
  this.addToCartButton = this.container.find('[data-product-page-add-to-cart]');

  this.container.on('click', '[data-product-page-add-to-cart]', this.onAddToCart.bind(this));

  $(document).on('onCartPending', this.onCartPending.bind(this));
  $(document).on('onCartFinished', this.onCartFinished.bind(this));
  $(document).on('onCartUpdate', this.onCartUpdate.bind(this));
}

ProductTemplate.prototype = Object.assign(ProductTemplate.prototype, {
  onAddToCart: function(e) {
    e.preventDefault();
    e.stopPropagation();
    window.Cart.add(this.variantSelector.val(), this.qtySelector.val());
  },

  onCartUpdate: function(e, newCart) {
  },

  onCartPending: function(e) {
    this.container.addClass('is-loading');
    this.addToCartButton.attr('disabled', 'disabled');
  },

  onCartFinished: function(e) {
    this.container.removeClass('is-loading');
    this.addToCartButton.removeAttr('disabled');
  }
});

$(document).ready(function() {
  $('[data-product-page]').each(function(e, i) {
    window.productTemplate = new ProductTemplate($(this));
  });

  
   ready('#bookmarkit', function(element) {
    if (window.innerWidth < 750) {
      $("#smartwishlist").appendTo("[data-wishlist-mobile]");
    }
   });
});





  var mainNavLinks = document.querySelectorAll(".c-product-gallery nav ul li a");
  var mainSections = document.querySelectorAll(".c-product-gallery__right section");

  var lastId;
  var cur = [];

  // This should probably be throttled.
  // Especially because it triggers during smooth scrolling.
  // https://lodash.com/docs/4.17.10#throttle
  // You could do like...
  // window.addEventListener("scroll", () => {
  //    _.throttle(doThatStuff, 100);
  // });


  window.addEventListener("scroll", function(e)  {
    var fromTop = window.scrollY;

    mainNavLinks.forEach(function(link) {
      var section = document.querySelector(link.hash);

      if (
        section.offsetTop <= fromTop &&
        section.offsetTop + section.offsetHeight > fromTop
      ) {
        link.classList.add("current");
      } else {
        link.classList.remove("current");
      }
    });
  });


$('body').on('click', '.c-product-gallery a', function(){
  var self = $(this);
  setTimeout(function(){
    self.addClass("current");
  },1000)
    
});





/*
 *  Blog Template
 *
 *  Version:
 *    1.0.0 - 2018/06/25
 */
var perPage = 4;//Match the perPage in blog.json.liquid
function BlogTemplate(container) {
  this.container = container;
  this.articleContainer = container.find('[data-article-container]');

  //Locate the articles container
  this.viewMore = this.container.find('[data-view-more]');
  this.page = 1;

  this.pendingRequest = null;

  //Existing articles?
  this.existingData = container.find('[data-blog-json]');
  if(this.existingData.length) {
    var raw = this.existingData.html();
    try {
      raw = JSON.parse(raw);
    } catch(e) {
      console.error(e);
      return;
    }
    this.parseJSON(raw, this.page || 1);
  }

  this.container.on('click', '[data-view-more]', this.fetchNext.bind(this));
}

BlogTemplate.prototype = {
  getBaseURL: function() {
    var url = window.location.pathname;
  },

  fetchNext: function() {
    this.fetchPage(this.page + 1);
  },

  isPrinted: function(id) {
    return this.container.find('[data-article-id="'+id+'"]').length;
  },

  fetchPage: function(page) {
    if(page <= 0) return;
    if(this.pendingRequest != null) return;//Already pending
    var params = {
      view: 'json',
      page: page
    };

    var requestParams = {
      template: this,
      params: params
    };

    var request = $.ajax({
      url: this.getBaseURL(),
      data: params,
      method: 'GET',
      error: this.onError.bind(requestParams),
      success: this.onData.bind(requestParams)
    });
    requestParams.request = request;
    this.pendingRequest = request;
  },

  onError: function(e, a, b) {
    this.pendingRequest = null;
    console.error(e);
    console.error(a);
    console.error(b);
  },

  onData: function(e) {
    this.template.pendingRequest = null;
    this.dataRaw = e;
    this.data = JSON.parse(e);
    this.template.parseJSON(this.data, this.params.page);
  },

  parseJSON: function(json, page) {
    this.data = json.blog;
    this.page = page;
    for(var i = 0; i < json.articles.length; i++) {
      var article = json.articles[i];
      if(this.isPrinted(article.id)) continue;
      this.articleContainer.append(article.data);
    }
    if(json.articles.length < perPage) {
      this.onArticlesFetched();
    }
  },

  onArticlesFetched: function() {
    this.viewMore.css('display', 'none');
  }
};

//Initializers
window.blogTemplate = [];

$(document).ready(function() {
  $('[data-blog-page]').each(function(e, i) {
    var template = new BlogTemplate($(this));
    window.blogTemplate.push(template);
    window.blogTemplateLast = template;//Used for easier accessing from in-browser console
    //console.log(template);
  });
});


$(document).ready(function() {

    //Anchor scroll
    if ($('[data-scroll-section]').length > 0) {
      var currentPage = $('[data-scroll-section]').data('scroll-section');
      var scrollElement = $('#'+currentPage).offset().top;
      $(window).scrollTop(scrollElement);
    }

        //Account Nav
    $('body').on('click','[data-show-orders]', function(e){

      $('[data-details-sections]').hide();
      $('[data-orders-sections]').fadeIn();
      $('.c-account-page__sidebar__nav a').removeClass('current');
      $(this).addClass('current');

    });
    $('body').on('click','[data-show-details]', function(e){

      $('[data-orders-sections]').hide();
      $('[data-details-sections]').fadeIn();
      $('.c-account-page__sidebar__nav a').removeClass('current');
      $(this).addClass('current');

    });

    //Account orders
    $('body').on('click','[data-order-trigger]', function(e){
      e.preventDefault();
      var orderId = $(this).data('order-trigger');
      console.log('#'+orderId);
      $('.c-account-page__section--orders-details').hide();
      $('#'+orderId).fadeIn();
    });

    //Animations
    AOS.init({
      duration: 800,
      once: true
    });

    //Bold tiers dropdown
    //$('[data-tiers]').hide(); 
    $('body').on('focus', '[data-quantity-selector-input]' , function () {
      var tiers = $(this).parent().next('[data-tiers]');
      tiers.slideDown();
    });

    $('body').on('blur', '[data-quantity-selector-input]' , function () {
      var tiers = $(this).parent().next('[data-tiers]');
      tiers.slideUp();
    });  

    //Article page manipulation
    if ($('[data-masonry-layout]').length > 0 ) {
      //var articleContent = $('[data-article-text]').html();
      var articleText = $('[data-masonry-layout]').text();
      //$('[data-article-text]').text(articleText);
      var imagesArray = [];
      $('[data-masonry-layout] img').each(function () {
          //$(this).detach().appendTo('.slider > figure');
          imagesArray.push($(this).get(0));
          //$(this).remove();
      });
      $('[data-masonry-layout]').empty();
      for (var i = 0; i <= 5 ; i++) {
        if (i == 4) {
          $('[data-masonry-layout]').append('<div class="c-article__masonry__content" >' + articleText +'</div>');
        } 
        var img = imagesArray[i];
        $('[data-masonry-layout]').append(img);        
      }
    }

    //multiple page links
    
    $('body').on('click','[data-internal-link]', function(e){
      $('[data-internal-link]').removeClass('off');
      $(this).addClass('off');
    });

    function onScroll(event){
        var scrollPos = $(document).scrollTop();
        $('[data-internal-link]').each(function () {
            var currLink = $(this);
            var refElement = $(currLink.attr("href"));
            //console.log('current scroll is '+ scrollPos + 'and elem pos is ' + refElement.position().top);
            if (refElement.position().top <= scrollPos ) { // && refElement.position().top + refElement.height() > scrollPos
                $('[data-internal-link]').removeClass("off");
                currLink.addClass("off");
            }
            else{
                currLink.removeClass("off");
            }
        });
    }

    $(document).on("scroll", onScroll);


    /*
    $('body').on('focus', '[data-quantity-selector-input]' , function () {
      var mainContainer = $(this).closest('.c-section__featured-products');
      console.log(mainContainer);
      var tiers = $(this).parent().next('[data-tiers]');
      var parallaxImage = $(this).closest('.c-section--parallax').data('image-src');
      var parallaxMirror = $('body').find("img[src='"+parallaxImage+"']").parent();
      tiers.slideDown();
      if(!mainContainer.hasClass('opened')){
        mainContainer.addClass('opened');
        var height  = parallaxMirror.height();
        parallaxMirror.css('height', height + 100);
      }

    });


    $('body').on('blur', '[data-quantity-selector-input]' , function () {
        var mainContainer = $(this).closest('.c-section__featured-products');
        mainContainer.removeClass('opened');
        var tiers = $(this).parent().next('[data-tiers]');
        var parallaxImage = $(this).closest('.c-section--parallax').data('image-src');
        var parallaxMirror = $('body').find("img[src='"+parallaxImage+"']").parent();
        tiers.slideUp();
        var height  = parallaxMirror.height();
        parallaxMirror.css('height', height - 100);

    });  

    */


});
